{
  "app": {
    "name": "ClearDCR",
    "maker": "A product of Bohniman",
    "skipToContent": "Skip to main content",
    "mainNavigation": "Main navigation",
    "signOut": "Sign out",
    "account": "Your account",
    "theme": {
      "label": "Colour theme",
      "light": "Light",
      "dark": "Dark",
      "system": "Same as device"
    }
  },
  "help": {
    "label": "Help desk",
    "menu": "Help and feedback",
    "email": "Email the help desk",
    "call": "Call {{phone}}",
    "page": "Help and feedback page",
    "newTab": "(opens in a new tab)",
    "signIn": "Can't sign in, or not sure where to start? The help desk can help.",
    "result": "Something in this result unclear, or wrong? Tell the help desk; it helps us improve the check."
  },
  "roles": {
    "ARCHITECT": "Architect",
    "OFFICER": "Officer",
    "ADMIN": "Administrator",
    "PLATFORM": "Platform administrator"
  },
  "nav": {
    "home": "Dashboard",
    "preChecks": "Check a drawing",
    "applications": "My applications",
    "reviewQueue": "Applications to review",
    "members": "People",
    "bylaws": "Bylaws",
    "scrutinyParameters": "Scrutiny parameters",
    "formulas": "Formulas",
    "byelawRegister": "Byelaw register",
    "auditLog": "Activity log",
    "authorities": "Authorities",
    "accounts": "Accounts",
    "zonesUses": "Zones and uses",
    "settings": "Settings",
    "states": "States",
    "platformActivity": "Platform activity",
    "integrations": "Integrations",
    "licences": "Desktop licences",
    "golden": "Golden set",
    "platformGolden": "Golden set",
    "mmsgnaGuide": "MMSGNA drawing guide",
    "aubbGuide": "AUBB card drawing guide",
    "obpasGuide": "OBPAS layer guide"
  },
  "authority": {
    "workingFor": "Working for {{name}}",
    "switch": "Switch authority",
    "chooseTitle": "Which authority are you working for?",
    "chooseIntro": "Your account works for more than one authority. Each has its own bylaws. Choose one; you can switch at any time.",
    "choose": "Work for {{name}}",
    "inUse": "In use",
    "noneTitle": "You're not a member of any authority yet",
    "noneBody": "Ask your authority's administrator to add you. Once they have, sign in again.",
    "state": "State: {{state}}"
  },
  "signIn": {
    "title": "Sign in",
    "intro": "Sign in to check drawings, submit applications and review them.",
    "email": "Email address",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "emailRequired": "Enter your email address.",
    "emailInvalid": "Enter an email address like name@example.com.",
    "passwordRequired": "Enter your password."
  },
  "code": {
    "title": "Enter your sign-in code",
    "intro": "Open your authenticator app and enter the 6-digit code it shows for this account.",
    "label": "6-digit code",
    "submit": "Continue",
    "useRecovery": "Use a recovery code instead",
    "useApp": "Use the authenticator app instead",
    "recoveryLabel": "Recovery code",
    "recoveryIntro": "Enter one of the recovery codes you saved when you set up sign-in codes. Each works once.",
    "codeRequired": "Enter the 6-digit code.",
    "recoveryRequired": "Enter a recovery code."
  },
  "password": {
    "title": "Choose a new password",
    "introOneTime": "You signed in with a one-time password. Choose your own before you continue.",
    "intro": "Choose a new password. Other devices signed in to your account will be signed out.",
    "current": "Current password",
    "new": "New password",
    "newHint": "At least 12 characters. A few unrelated words make a strong password.",
    "confirm": "Type the new password again",
    "submit": "Save password",
    "mismatch": "The two new passwords don't match.",
    "tooShort": "Use at least 12 characters.",
    "saved": "Your password is changed."
  },
  "setUpCodes": {
    "title": "Set up sign-in codes",
    "intro": "Your role needs a second step at sign-in: a code from an authenticator app on your phone.",
    "step1": "Install an authenticator app, such as Google Authenticator or Microsoft Authenticator.",
    "step2": "Scan this QR code with the app, or type the key below into it.",
    "qrAlt": "QR code for your authenticator app",
    "key": "Key for typing in by hand",
    "step3": "Enter the 6-digit code the app now shows.",
    "submit": "Turn on sign-in codes",
    "recoveryTitle": "Save your recovery codes",
    "recoveryIntro": "If you lose your phone, each of these codes lets you sign in once. Keep them somewhere safe; they won't be shown again.",
    "copy": "Copy the codes",
    "copied": "Copied",
    "done": "I've saved them"
  },
  "home": {
    "title": "Welcome, {{name}}",
    "architectIntro": "Check a drawing against your authority's bylaws before you submit it. Problems are listed with how to fix them, and many can be fixed here.",
    "startCheck": "Check a drawing",
    "officerIntro": "Applications waiting for review are in your queue. Open one to see the drawing beside its figures, bylaw results and the architect's declared values.",
    "openQueue": "Open the review queue",
    "adminIntro": "Manage your authority's people, the zones and uses architects choose from, and its bylaw rule sets. Connect your BPA system under Integrations, and issue desktop checker licences under Desktop licences. Every change is recorded in the activity log.",
    "platformIntro": "Set up states and their authorities, give each authority its first administrator, and manage accounts across the platform."
  },
  "states": {
    "loading": "Loading…",
    "errorTitle": "Something went wrong",
    "errorBody": "We couldn't load this. Check your connection and try again.",
    "retry": "Try again",
    "notFoundTitle": "Page not found",
    "notFoundBody": "The address may be mistyped, or the page may have moved.",
    "goHome": "Go to the home page"
  },
  "errors": {
    "auth.invalid_credentials": "The email or password is wrong, or the account is locked for a while after too many attempts.",
    "auth.invalid_mfa_code": "That code didn't work. Codes change every 30 seconds; try the current one.",
    "auth.sign_in_required": "Your session has ended. Please sign in again.",
    "auth.csrf_failed": "This page is out of date. Refresh it and try again.",
    "auth.current_password_incorrect": "The current password is wrong.",
    "auth.password_too_short": "Use at least 12 characters.",
    "auth.password_too_long": "That password is too long.",
    "auth.password_unchanged": "Choose a password different from the current one.",
    "auth.authority_required": "Choose the authority you're working for first.",
    "auth.forbidden": "Your account can't do this.",
    "authority.not_found": "You aren't a member of that authority.",
    "network": "We couldn't reach the server. Check your connection and try again.",
    "unknown": "Something went wrong. Try again, and if it keeps happening, contact support.",
    "upload.too_large": "The file is larger than the limit. Purge unused blocks and layers (PURGE), then try again.",
    "upload.empty": "The file is empty. Save the drawing again and choose the new file.",
    "upload.not_a_drawing": "This isn't a DXF drawing. Save it as DXF in your CAD program and try again.",
    "upload.dwg_not_accepted": "DWG files aren't accepted. Save the drawing as DXF in your CAD program (Save As, then a DXF file type) and upload that file.",
    "upload.not_found": "The upload has expired. Choose the file again.",
    "pre_check.not_found": "This check doesn't exist, or it has been deleted after 7 days.",
    "pre_check.limit_reached": "You've reached today's limit of checks. Try again tomorrow.",
    "zone.not_found": "That zone isn't in your authority's list.",
    "use.not_found": "That building use isn't in your authority's list.",
    "edit.nothing_to_do": "There are no changes to make.",
    "edit.too_many_operations": "That's too many changes at once. Make some, check again, then make the rest.",
    "edit.drawing_not_checked": "Wait for the check to finish before making changes.",
    "job.file_not_found": "This file isn't available for this check.",
    "job.not_found": "This check isn't available. It may have been deleted.",
    "job.not_completed": "This check hasn't finished yet. Wait a moment and try again.",
    "user.not_found": "There is no such person.",
    "user.email_taken": "An account with this email already exists.",
    "user.cannot_change_own_account": "You can't change your own account here; ask another administrator.",
    "user.account_shared": "This account also works for another authority, so only its role here can change. Its password and codes are changed there or by a platform administrator.",
    "membership.already_a_member": "This person already works for your authority.",
    "zone.exists": "A zone with this code already exists.",
    "use.exists": "A use with this code already exists.",
    "rule_set.not_found": "There is no such rule set.",
    "rule_set.exists": "A rule set with this name and version already exists.",
    "rule_set.not_draft": "Only a draft can be changed. Start a new version to correct a published set.",
    "rule_set.not_published": "Only a published rule set can be retired or copied from the library.",
    "rule_set.not_publishable": "The rule set has problems to fix first. Check it to see them.",
    "rule_set.needs_second_admin": "Another administrator must publish this: you made the last change to it.",
    "rule_set.missing_references": "The file names zones or uses this authority doesn't have. Tick the box to add them, or add them first.",
    "rule.not_found": "There is no such row.",
    "rule.unknown_zone": "That zone isn't in your authority's list.",
    "rule.unknown_use": "That use isn't in your authority's list.",
    "authority.exists": "An authority with this code already exists.",
    "state.not_found": "There is no such state.",
    "state.exists": "A state with this code already exists.",
    "approval.not_found": "No approval matches this link.",
    "approval.not_configured": "Approved drawings can't be issued yet. Ask the platform administrator to set up the QR and signing keys.",
    "approval.not_ready": "The approved drawing isn't ready yet.",
    "auth.acting_architect_required": "Name the architect the request is made for.",
    "auth.acting_architect_invalid": "That email isn't an active architect of this authority.",
    "api_client.not_found": "There is no such system.",
    "webhook.not_found": "There is no such webhook.",
    "webhook.url_invalid": "Give an https:// address with no user name or password in it.",
    "licence.not_found": "There is no such licence.",
    "licence.not_an_architect": "Licences are for active architects of this authority.",
    "licence.end_date_past": "The last day has already passed.",
    "licence.key_invalid": "That isn't a valid licence key. Check it and try again.",
    "licence.in_use": "This licence is already activated on another computer. Ask your authority to release it.",
    "licence.revoked": "This licence has been revoked.",
    "licence.expired": "This licence has ended.",
    "licence.architect_inactive": "The licence holder is no longer an active architect of the authority.",
    "licence.device_unknown": "This computer's licence isn't activated. Activate it again.",
    "desktop.not_configured": "The desktop checker isn't set up on this server yet.",
    "desktop.server_unreachable": "The checker needs the internet to confirm your licence. Check your connection and try again.",
    "desktop.no_licence": "No licence is chosen on this computer. Activate one or choose one below.",
    "desktop.untrusted_answer": "The answer about your licence didn't come from the server. Try again, or on another network.",
    "desktop.not_opened": "Open the checker from its icon on this computer.",
    "rate.limited": "Too many requests in a short time. Wait a moment, then try again.",
    "golden.not_found": "There is no such drawing in the golden set.",
    "golden.revision_not_found": "Only a submitted drawing can be added to the golden set.",
    "golden.not_checked": "Wait until the drawing has been checked.",
    "golden.no_values": "Save the figures you checked before signing.",
    "golden.unknown_value": "Every figure must be a number of zero or more.",
    "golden.not_a_blocker": "Only codes that stop a drawing being read can be listed here.",
    "golden.retired": "This drawing has been taken out of the golden set.",
    "golden.already_added": "This drawing is already in the golden set.",
    "knowledge_base.off": "This drawing wasn't checked against the byelaw knowledge base.",
    "knowledge_base.unavailable": "There is no byelaw knowledge base for your state yet.",
    "knowledge_base.needs_officer": "The byelaws knowledge base needs officers for what it can't decide, so it can't be on while applications are approved automatically with no officers. Under “Who decides applications”, choose “An officer decides every application” or “Approve automatically; officers decide the rest”, or turn the knowledge base off.",
    "conversion.not_ready": "This drawing can't be converted yet: its check hasn't finished, or it was checked before the conversion tool. Upload it again to convert it.",
    "conversion.incomplete": "Some areas still need you: run the checklist and deal with each one first.",
    "drawing_guide.not_found": "There is no drawing guide for this."
  },
  "verdict": {
    "CHECKING": "Checking",
    "READY_TO_SUBMIT": "Ready to submit",
    "FIX_REQUIRED": "Fix required",
    "CANNOT_READ_DRAWING": "Cannot read drawing",
    "EDIT_REFUSED": "Changes not made"
  },
  "severity": {
    "BLOCKER": "Blocker",
    "ERROR": "Error",
    "WARNING": "Warning",
    "INFO": "Note",
    "plural": {
      "BLOCKER": "{{count}} blockers",
      "ERROR": "{{count}} errors",
      "WARNING": "{{count}} warnings",
      "INFO": "{{count}} notes"
    },
    "explain": {
      "BLOCKER": "The drawing can't be measured until these are fixed.",
      "ERROR": "These must be fixed before you submit.",
      "WARNING": "Check these; they may be fine.",
      "INFO": "For your information."
    }
  },
  "stages": {
    "title": "Checking your drawing",
    "waiting": "Waiting to start",
    "UPLOADING": "Uploading drawing",
    "READING": "Reading drawing",
    "CHECKING_LAYERS": "Checking layers",
    "MEASURING": "Measuring areas",
    "PREPARING_PREVIEW": "Preparing preview",
    "done": "Done",
    "current": "In progress",
    "pending": "Not started",
    "keepOpen": "This usually takes under a minute. You can leave this page; the result will be in your list."
  },
  "preCheck": {
    "listTitle": "Check a drawing",
    "listIntro": "Upload a drawing to check it against your authority's bylaws. Checks are kept for 7 days.",
    "new": "Check a new drawing",
    "emptyTitle": "You haven't checked any drawings yet",
    "emptyBody": "Upload a DXF file to see what needs fixing before you apply.",
    "file": "Drawing",
    "checked": "Checked",
    "result": "Result",
    "open": "Open the check of {{name}}",
    "fixedCopy": "Fixed copy",
    "expires": "Kept until {{date}}",
    "delete": "Delete",
    "deleteConfirm": "Delete the check of {{name}}? This can't be undone.",
    "deleted": "The check is deleted.",
    "newTitle": "Check a new drawing",
    "newIntro": "Your drawing is checked against the bylaws of {{authority}}.",
    "correctedTitle": "Check the corrected drawing",
    "correctedIntro": "Attempt {{attempt}} of the scrutiny of {{name}}. Its details are filled in: change any that differ.",
    "backToResult": "Back to the result",
    "sections": {
      "drawing": "Drawing",
      "plot": "Plot and owner"
    },
    "step": "Step {{step}}",
    "stepsLabel": "The steps of a check",
    "ownerName": "Owner's name",
    "ownerNameHint": "As in the land records. It is printed in the scrutiny report.",
    "ownerNameRequired": "Enter the owner's name.",
    "ownerLine": "Owner: {{name}}",
    "tooLong": "This is too long.",
    "formNote": "Nothing is submitted: this is a draft check.",
    "cancel": "Cancel",
    "submitCorrected": "Check the corrected drawing",
    "newScrutiny": "Start a new scrutiny",
    "again": {
      "title": "Fixed the drawing? Check it again",
      "titleChanged": "Changed the drawing? Check it again",
      "body": "Upload the corrected DXF only. It is checked as attempt {{attempt}} of this scrutiny, with the same details.",
      "changeDetails": "Change the details"
    },
    "attempts": {
      "title": "Attempts of this scrutiny",
      "item": "Attempt {{attempt}}",
      "current": "this one"
    },
    "deleteAttemptsConfirm": "Delete the scrutiny of {{name}} and its {{count}} attempts? This can't be undone.",
    "drop": {
      "label": "Drawing file",
      "title": "Drag your drawing here",
      "titleCompact": "Drag your DXF here, or choose it",
      "change": "Change file",
      "corrected": "Corrected drawing",
      "or": "or",
      "choose": "Choose a file",
      "hint": "DXF, up to {{size}}.",
      "selected": "Selected: {{name}} ({{size}})",
      "remove": "Choose a different file",
      "wrongType": "This isn't a DXF file. Save the drawing as DXF and try again.",
      "dwg": "DWG files aren't accepted. Save the drawing as DXF in your CAD program (Save As, then a DXF file type) and choose that file.",
      "tooLarge": "This file is {{size}}; the limit is {{limit}}. Purge unused blocks and layers (PURGE), or remove images, then try again.",
      "empty": "This file is empty. Save the drawing again and choose the new file.",
      "required": "Choose a drawing file."
    },
    "zone": "Zone",
    "zoneHint": "The zone of the plot in the master plan. Taken from GIS when available.",
    "zoneRequired": "Choose the zone.",
    "use": "Building use",
    "useRequired": "Choose the building use.",
    "choose": "Choose…",
    "roadWidth": "Existing road width in metres (optional)",
    "roadWidthHint": "The width of the road the plot faces today. Leave empty if it's written in the drawing.",
    "roadWidthShort": "Today's width. Leave empty if it's written in the drawing.",
    "roadWidthLabel": "Existing road width in metres",
    "roadWidthNeeded": "The road the plot faces, as it is today.",
    "roadWidthRequired": "Enter the existing road width.",
    "roadWidthInvalid": "Enter a width between 0 and 1000 metres, like 6 or 7.5.",
    "proposedRoadWidth": "Proposed road width in metres (optional)",
    "proposedRoadWidthHint": "Only if the road is to be widened: its width once widened, as the Master Plan gives it (or byelaw 23 where the Master Plan gives none). Leave empty if the road isn't to be widened. The front setback must leave room for the widening.",
    "proposedRoadWidthShort": "Only if the road will be widened: its width then.",
    "proposedRoadWidthLabel": "Proposed road width in metres",
    "proposedRoadWidthNeeded": "Its width once widened; today's width if it won't be widened.",
    "proposedRoadWidthRequired": "Enter the proposed road width: today's width if the road won't be widened.",
    "noZones": "Your authority hasn't set up its zones and uses yet. Ask its administrator.",
    "submit": "Check the drawing",
    "uploading": "Uploading… {{percent}}%",
    "starting": "Starting the check…",
    "detailTitle": "Check of {{name}}",
    "backToList": "All checks",
    "summary": "Summary",
    "zoneUse": "Zone {{zone}} · {{use}}",
    "draftNote": "Draft — final check at submission",
    "cannotRead": "We couldn't read this drawing",
    "cannotReadNext": "Fix the problems below, save the drawing, and check it again.",
    "editRefused": "Your changes couldn't be made safely, so the drawing was left as it was.",
    "readyBody": "No problems were found. You can submit this drawing with your application.",
    "fixBody": "Fix the problems below, then check the drawing again.",
    "noProblems": "No problems found",
    "checkAgain": "Check another drawing",
    "fixedFrom": "This is a fixed copy of an earlier check.",
    "seeOriginal": "See the earlier check",
    "submitDrawing": "Submit this drawing",
    "submitHint": "Starts an application with this drawing and its details. You add the site before submitting.",
    "submitWithProblems": "You can start an application now and fix the problems in it before you submit.",
    "search": "Search checks",
    "columns": {
      "drawing": "Drawing",
      "owner": "Owner",
      "result": "Result",
      "zoneUse": "Zone and use",
      "checked": "Checked",
      "keptUntil": "Kept until",
      "actions": "Actions"
    },
    "convert": "Convert to the drawing standard",
    "convertTitle": "Drawn without the standard's layers?",
    "convertBody": "The conversion tool helps you put your drawing on the standard's layers: it traces each area from your lines, and you confirm. Nothing in your drawing is lost.",
    "colourCard": "This authority reads drawings by the MMSGNA colour card: draw each outline (plot, building, floors, rooms, stairs, balconies, parking, the septic tank and recharge pits, landscaping) and each height in its colour on the card, and write the plan titles, room names, the septic tank's capacity and road width as you usually do.",
    "aubbCard": "This authority reads drawings by the AUBB colour card: draw each outline (plot, buildings, floors, rooms, flats, stairs, balconies, parking, the septic tank and recharge pits, landscaping and other open spaces, the fire tender's path) and each height in its colour on the card, and write the plan titles, room names, the septic tank's capacity and road width as you usually do. With several buildings on the plot, write each one's name inside its outline in the site plan (BLOCK A) and in its plans' and sections' titles.",
    "colourCardShort": "Draw each outline and height in its colour on the MMSGNA colour card.",
    "aubbCardShort": "Draw each outline and height in its colour on the AUBB colour card, and name each building inside its outline.",
    "openGuide": "Open the drawing guide",
    "roadsFirst": "Enter each road's proposed width first, under Proposed road widths."
  },
  "quantities": {
    "title": "Key figures",
    "plotArea": "Plot area",
    "far": "Floor area ratio (FAR)",
    "coverage": "Ground coverage",
    "height": "Building height",
    "setbacks": "Setbacks",
    "setbacksNew": "Setbacks of the new work",
    "setbacksExisting": "Setbacks of the existing building",
    "toBeRegularised": "Short of the minimum: to be regularised",
    "farParts": "FAR: existing and new work",
    "farPartsValue": "{{existing}} existing · {{proposed}} new",
    "existingFloorAreaColumn": "Existing floor area (m²)",
    "serviceType": {
      "NEW": "New construction",
      "ADDITION": "Addition to an existing building",
      "ALTERATION": "Alteration of an existing building",
      "REVISION": "Revision of an earlier approval"
    },
    "farAsDrawn": "As drawn: ({{builtUp}} − {{exempted}}) ÷ {{plot}} m², before bylaw caps",
    "exempted": "Exempted area",
    "floorAreaValue": "Floor area {{value}} m²",
    "exemptedColumn": "Exempted (m²)",
    "floorAreaColumn": "Floor area (m²)",
    "floorHeight": "Floor height",
    "parking": "Parking",
    "parkingValue": "{{car}} car, {{twoWheeler}} two-wheeler",
    "notMeasured": "Not measured",
    "allowed": "Allowed: {{value}}",
    "required": "Required: {{value}}",
    "perFloor": "Areas by floor",
    "floor": "Floor",
    "block": "Block {{block}}",
    "total": "Total",
    "noFloors": "No floor areas were measured.",
    "category": {
      "BUA": "Built-up area",
      "BALCONY": "Balcony",
      "CUPBOARD": "Cantilever cupboard",
      "STAIRCASE": "Staircase",
      "LIFT": "Lift",
      "DUCT": "Duct",
      "PARKING": "Parking, including stilt floors",
      "CANTILEVER": "Cantilever",
      "FOOTPRINT": "Footprint",
      "LOBBY": "Lobby",
      "CORRIDOR": "Corridor",
      "DEDUCTION": "Deductions as drawn",
      "BUA_EXISTING": "Existing built-up area",
      "DEDUCTION_EXISTING": "Existing deductions",
      "CARPET": "Carpet area"
    },
    "side": {
      "front": "front",
      "rear": "rear",
      "side": "side",
      "side1": "side 1",
      "side2": "side 2"
    },
    "setbackValue": "{{value}} m ({{side}})",
    "occupancy": "Use: {{occupancy}}"
  },
  "openCheck": {
    "title": "Opening the check",
    "opening": "Opening the check of this drawing…"
  },
  "reportViewer": {
    "title": "Scrutiny report",
    "intro": "The report of this check, as it will be printed. Download it to keep or share it.",
    "frameTitle": "The scrutiny report",
    "open": "Open in a new tab",
    "download": "Download the report (PDF)"
  },
  "details": {
    "title": "Stairs, lifts, services and more",
    "intro": "Measured from the drawing, as OBPAS reads them. These aren't checked against the bylaws here; an officer compares them.",
    "floor": "Floor {{number}}",
    "floorNames": {
      "-2": "Basement 2",
      "-1": "Basement 1",
      "0": "Ground floor",
      "1": "First floor",
      "2": "Second floor",
      "3": "Third floor",
      "4": "Fourth floor",
      "5": "Fifth floor",
      "6": "Sixth floor",
      "7": "Seventh floor",
      "8": "Eighth floor",
      "9": "Ninth floor",
      "10": "Tenth floor"
    },
    "stair": "{{floor}}, stair {{number}}",
    "fireStair": "{{floor}}, fire stair {{number}}",
    "flight": "{{stair}}, flight {{number}}",
    "flightValue": "width {{width}} · {{risers}} risers · tread {{tread}}",
    "landing": "{{stair}}, mid landing {{number}} width",
    "riserHeight": "{{stair}}, riser height",
    "stairs": "Staircases",
    "lifts": "Lifts",
    "liftCount": "Number of lifts (block {{block}})",
    "lift": "Lift {{number}} car",
    "lobbiesBalconies": "Lobbies and balconies",
    "lobby": "Lobby width, {{floor}}",
    "balcony": "Balcony width, {{floor}}",
    "boundary": "Balconies to the plot boundary, {{floor}}",
    "services": "Site services and open space",
    "rwhCapacity": "Rain-water harvesting capacity",
    "litres": "{{value}} litres",
    "pits": "Percolation pits",
    "pitVolume": "Percolation pits' volume",
    "septic": "Septic tank capacity",
    "biodegradable": "Biodegradable waste treatment area",
    "settlingTank": "Settling tank",
    "overheadTank": "Overhead tank",
    "recreational": {
      "LANDSCAPING": "Landscaping",
      "EVERGREEN TREES": "Evergreen trees",
      "ORGANISED OPEN SPACE": "Organised open space",
      "RECREATIONAL OPEN SPACE": "Recreational open space",
      "UNPAVED AREA": "Unpaved area"
    },
    "roofAndDrawing": "Roof structures and the drawing",
    "roof": {
      "MUMTY_HT": "Stair cover (mumty) height",
      "ROOF_WATER_TANK_HT": "Roof tank height",
      "CHIMNEY_HT": "Chimney height"
    },
    "parapet": "Parapet height, {{floor}}",
    "locationPlan": "Location plan drawn",
    "northDirection": "North direction drawn",
    "yes": "Yes",
    "no": "No"
  },
  "earlier": {
    "title": "Earlier approval",
    "permit": "Earlier permit: {{number}}",
    "approval": "approval {{number}} ({{status}})",
    "status": {
      "VALID": "valid",
      "EXPIRED": "expired",
      "SUPERSEDED": "superseded",
      "REVOKED": "revoked"
    },
    "outcome": {
      "MATCHES": "The existing floors are drawn as approved.",
      "DIFFERS": "The existing floors differ from the approval.",
      "REVOKED": "The earlier approval was revoked.",
      "NOT_IN_THIS_SYSTEM": "This permit wasn't issued through this system, so an officer checks the existing floors."
    },
    "floorOutcome": {
      "MATCHES": "As approved",
      "DIFFERS": "Differs",
      "NOT_APPROVED": "Not in the approval",
      "NOT_DRAWN": "Approved, not drawn as existing"
    },
    "plotDiffers": "The plot differs from the approved plot.",
    "approved": "Approved built-up area (m²)",
    "drawn": "Existing built-up area drawn (m²)",
    "note": "Each existing floor's built-up area is compared with the approved drawing's, within {{tolerance}}%. The officer also checks the building on site."
  },
  "bylaws": {
    "title": "Bylaw results",
    "item": "Check",
    "required": "Required",
    "provided": "In the drawing",
    "outcome": "Result",
    "PASS": "Meets",
    "FAIL": "Does not meet",
    "NOT_CHECKED": "Not checked",
    "MEASURED": "Measured only",
    "warning": {
      "B006": "Added to FAR",
      "B012": "To be regularised",
      "B023": "Added to FAR",
      "B027": "Added to height"
    },
    "atMost": "at most {{value}}",
    "atLeast": "at least {{value}}",
    "roadWidening": "including {{value}} for the road's widening",
    "alongRoad": "along “{{road}}”: the front setback applies",
    "provisional": "Provisional rule: shown, but it doesn't decide the result until the department verifies it.",
    "none": "No bylaw checks ran for this drawing.",
    "ruleSet": "Rules: {{name}}",
    "reason": {
      "no_rule_set": "Your authority has no published bylaws for this zone and use.",
      "no_matching_rule": "No rule covers this plot.",
      "ambiguous_rules": "More than one rule applies; an officer will decide.",
      "needs_road_width": "Enter the road width to check this.",
      "not_measured": "Couldn't be measured from the drawing.",
      "not_in_rule": "Not part of this authority's rules.",
      "needs_balcony_cap": "The bylaws don't set a balcony limit.",
      "needs_cupboard_cap": "The bylaws don't set a cantilever cupboard limit.",
      "no_habitable_room": "The cupboard doesn't project from a habitable room.",
      "needs_far_rule": "Needs the FAR rule.",
      "unlabelled_room": "The room has no label.",
      "no_new_work": "The drawing shows no new construction to measure.",
      "below_floor_threshold": "The height limit applies only to buildings with more floors.",
      "needs_plot_answers": "Answer whether the plot is within a ULB area and whether it is for EWS/LIG housing to check this.",
      "needs_proposed_road_width": "Enter the proposed width of the road along it (today's if it won't be widened) to check this."
    },
    "items": {
      "far": "Floor area ratio (FAR)",
      "coverage": "Ground coverage",
      "height": "Building height",
      "parking.car": "Car parking bays",
      "parking.two_wheeler": "Two-wheeler parking bays",
      "balcony": "Balcony area",
      "room": "Room size",
      "room.area": "Room area",
      "room.width": "Room width",
      "plot_area.min": "Smallest plot allowed",
      "plot_area.max": "Largest plot allowed",
      "plot.frontage": "Plot frontage",
      "plot.width": "Plot width",
      "floors": "Number of floors",
      "road_width": "Road width",
      "setback.front": "Front setback",
      "setback.rear": "Rear setback",
      "setback.side": "Side setback",
      "far.existing": "FAR of the existing floors",
      "far.proposed": "FAR of the new work",
      "far.exemptions": "Areas exempted from FAR (within their cap)",
      "mezzanine": "Mezzanine area",
      "height_exemption.roof_tank": "Roof tank height (height exemption)",
      "height_exemption.mumty": "Stair cover (mumty) height (height exemption)",
      "height_exemption.chimney": "Chimney height (height exemption)",
      "plinth_height.min": "Plinth height, lowest allowed",
      "plinth_height.max": "Plinth height, highest allowed",
      "floor_height": "Floor height",
      "floor_height.parking": "Parking floor height",
      "setback_existing.front": "Existing building's front setback (to be regularised)",
      "setback_existing.rear": "Existing building's rear setback (to be regularised)",
      "setback_existing.side": "Existing building's side setback (to be regularised)",
      "stair.flight_width": "Stair flight width",
      "stair.tread": "Stair tread",
      "stair.risers": "Risers in a stair flight",
      "stair.landing_width": "Stair mid-landing width",
      "stair.riser_height": "Stair riser height",
      "fire_stair.flight_width": "Fire stair flight width",
      "fire_stair.tread": "Fire stair tread",
      "fire_stair.risers": "Risers in a fire stair flight",
      "fire_stair.landing_width": "Fire stair mid-landing width",
      "fire_stair.riser_height": "Fire stair riser height",
      "lift.count": "Number of lifts",
      "lift.car_width": "Lift car width",
      "lift.car_depth": "Lift car depth",
      "lobby.width": "Lobby width",
      "balcony.width": "Balcony width",
      "balcony.boundary_distance": "Balcony distance from the plot boundary",
      "cupboard": "Cantilever cupboard area",
      "cupboard.depth": "Cantilever cupboard depth",
      "cupboard.length": "Cantilever cupboards' length beside a habitable room",
      "rwh.capacity": "Rain-water harvesting capacity",
      "rwh.pits": "Percolation pits",
      "septic.capacity": "Septic tank capacity",
      "recreational.landscaping": "Landscaping (share of the plot)",
      "recreational.organised_open_space": "Organised open space (share of the plot)",
      "roof.mumty": "Stair cover (mumty) height",
      "roof.roof_tank": "Roof tank height",
      "roof.chimney": "Chimney height",
      "roof.parapet": "Parapet height"
    },
    "units": {
      "ratio": "{{value}}",
      "percent": "{{value}}%",
      "m": "{{value}} m",
      "m2": "{{value}} m²",
      "bays": "{{value}} bays",
      "floors": "{{value}} floors",
      "count": "{{value}}",
      "litres": "{{value}} litres"
    }
  },
  "problems": {
    "title": "Problems to fix",
    "none": "Nothing to fix.",
    "unplaced": "Whole drawing",
    "floor": "Floor: {{floor}}",
    "howToFix": "How to fix",
    "limitation": "What the check can't do ({{code}})",
    "showOnDrawing": "Show problem {{number}} on the drawing",
    "number": "Problem {{number}}",
    "fixHere": "Fix it here",
    "fixQueued": "Will be fixed",
    "undoFix": "Don't fix",
    "fixAll": "Fix all {{count}} automatically",
    "fixAllHint": "Closes open outlines, removes duplicates and creates missing layers. You get a fixed copy to download; your file isn't changed.",
    "layer": "Layer {{layer}}"
  },
  "limitations": {
    "title": "What this check does not cover",
    "intro": "An officer checks these by hand."
  },
  "downloads": {
    "title": "Downloads",
    "pdf": "Scrutiny report (PDF)",
    "pdfHint": "The status, plot and floor areas, and each check, required against provided.",
    "png": "Marked-up preview (PNG)",
    "markup": "Problems as a CAD layer (DXF)",
    "markupHint": "Open it in AutoCAD or similar alongside your drawing: each problem is marked and numbered.",
    "csv": "Problem list (CSV)",
    "drawing": "The drawing checked (DXF)",
    "drawingPdf": "The drawing (PDF)",
    "drawingPdfHint": "The drawing as uploaded, for printing or sharing."
  },
  "viewer": {
    "label": "Drawing of {{name}}",
    "loading": "Loading the drawing…",
    "failed": "The drawing couldn't be shown. The downloads below still work.",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "fit": "Fit to screen",
    "maximise": "Maximise the drawing",
    "restore": "Restore the drawing's size (Esc)",
    "zoomSelection": "Zoom to selection",
    "keyboard": "Use the arrow keys to move, + and − to zoom, and 0 to fit the drawing.",
    "tools": "Tools",
    "pan": "Move",
    "select": "Select",
    "measureDistance": "Measure distance",
    "measureArea": "Measure area",
    "distance": "Distance: {{value}} m",
    "area": "Area: {{value}} m² · Perimeter {{perimeter}} m",
    "measureHint": "Click points on the drawing. Press Enter or double-click to finish, Escape to clear.",
    "floor": "Floor",
    "allFloors": "Whole drawing",
    "floorName": "{{label}}",
    "unlabelled": "Unlabelled floor",
    "layers": "Layers",
    "searchLayers": "Search layers",
    "showAll": "Show all",
    "hideAll": "Hide all",
    "shapes": "{{count}} shapes",
    "noLayers": "No layer matches.",
    "showHide": "Show and hide",
    "tabLayers": "Layers",
    "tabColours": "Colours",
    "searchColours": "Search colours",
    "colourNumber": "Colour {{aci}}",
    "trueColour": "True colour {{hex}}",
    "noColours": "No colour matches.",
    "onlyColour": "Only",
    "onlyColourLabel": "Show only {{name}}",
    "coloursHint": "Hide a colour, or show it alone, to see what is drawn in it: on a colour card each colour is one kind of outline.",
    "markerTitle": "{{number}}. {{code}}: {{message}}",
    "large": "This drawing has {{count}} shapes; small text is hidden until you zoom in.",
    "pin": "Place a comment",
    "pinHint": "Click the drawing where the comment belongs, then write it beside the drawing.",
    "noteTitle": "Comment {{number}} by {{author}}: {{text}}",
    "none": "There is no drawing to show for this check."
  },
  "fix": {
    "title": "Selected shape",
    "nothing": "Choose Select, then click a line, outline or text on the drawing to fix it here.",
    "notEditable": "This is part of a block. Explode the block in your CAD program to change it.",
    "moveToLayer": "Move to layer",
    "move": "Move",
    "setColour": "Colour number (1–255, or 256 for By layer)",
    "applyColour": "Set colour",
    "close": "Close the outline",
    "delete": "Delete",
    "convert": "Turn into a polyline",
    "pending": "Changes to make ({{count}})",
    "pendingIntro": "Nothing changes in your file. We make a fixed copy, check it again, and you can download it.",
    "remove": "Remove",
    "checkFixed": "Make these changes and check again",
    "working": "Making the changes…",
    "ops": {
      "setLayer": "Move {{object}} to layer {{layer}}",
      "setColour": "Set the colour of {{object}} to {{aci}}",
      "closePolyline": "Close {{object}}",
      "deleteEntity": "Delete {{object}}",
      "convertToPolyline": "Turn {{object}} into a polyline",
      "createLayer": "Create layer {{name}}",
      "resetDimensionText": "Show the measured value on {{object}}",
      "other": "Change {{object}}"
    },
    "object": {
      "known": "the {{kind}} on layer {{layer}}",
      "unknown": "an object"
    },
    "kinds": {
      "LINE": "line",
      "LWPOLYLINE": "polyline",
      "POLYLINE": "polyline",
      "CIRCLE": "circle",
      "ARC": "arc",
      "ELLIPSE": "ellipse",
      "SPLINE": "spline",
      "TEXT": "text",
      "MTEXT": "text",
      "DIMENSION": "dimension",
      "INSERT": "block",
      "HATCH": "hatch",
      "SOLID": "filled shape",
      "POINT": "point",
      "other": "object"
    },
    "typeLabel": "Type",
    "layerLabel": "Layer",
    "colourLabel": "Colour",
    "textLabel": "Text",
    "sideLabel": "Fixing the drawing and comments"
  },
  "applicationStatus": {
    "DRAFT": "Draft",
    "SUBMITTED": "Submitted",
    "UNDER_REVIEW": "Under review",
    "RETURNED": "Returned for changes",
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "REVOKED": "Approval revoked"
  },
  "application": {
    "listTitle": "My applications",
    "listIntro": "Applications you have started or submitted to your authority.",
    "new": "Start an application",
    "emptyTitle": "You have no applications yet",
    "emptyBody": "Check a drawing first; from its result, choose Submit this drawing.",
    "draftName": "Draft for {{owner}}",
    "title": "Application {{number}}",
    "updated": "Last changed {{date}}",
    "backToList": "All my applications",
    "newTitle": "Start an application",
    "newIntro": "It is saved as a draft. You can change it and fix the drawing before you submit it.",
    "drawingFromCheck": "Drawing: {{name}}, from your check",
    "create": "Save the draft",
    "ownerName": "Owner's name",
    "ownerNameRequired": "Enter the owner's name.",
    "ownerContact": "Owner's phone or email",
    "ownerContactHint": "Used by the authority to reach the owner.",
    "ownerContactRequired": "Enter the owner's phone number or email.",
    "siteAddress": "Site address",
    "siteAddressHint": "Plot number, village or ward, and district.",
    "siteAddressRequired": "Enter the site address.",
    "tooLong": "This is too long.",
    "zoneAndUse": "Zone and use",
    "roadWidth": "Road width",
    "proposedRoadWidth": "Proposed road width",
    "notGiven": "Not given",
    "architect": "Architect",
    "revision": "Version {{number}}",
    "returnedTitle": "Returned by {{officer}} for changes",
    "returnedAutomaticTitle": "Returned automatically for changes",
    "approvedTitle": "Approved",
    "approvedBody": "The signed approved drawing, with its QR code on every sheet, is below.",
    "rejectedTitle": "Rejected",
    "submit": "Submit the application",
    "resubmit": "Submit the changes",
    "submitHint": {
      "OFFICER": "Once submitted, an officer reviews it. You can't change it unless it is returned to you.",
      "AUTOMATIC": "Once submitted, it is approved at once if it passes every check; if not, an officer reviews it. You can't change it unless it is returned to you.",
      "AUTOMATIC_ONLY": "Once submitted, it is approved at once if it passes every check; if not, it comes back to you at once with the reasons, to change and submit again."
    },
    "submitted": "Submitted as {{number}}.",
    "cannotSubmit": {
      "CHECKING": "Wait for the drawing to be checked.",
      "CANNOT_READ_DRAWING": "The drawing couldn't be read. Replace it with a readable one.",
      "EDIT_REFUSED": "The last changes couldn't be made. Replace the drawing or try the changes again."
    },
    "changeDetails": "Change the owner, site, zone or use",
    "saveDetails": "Save the changes",
    "replaceDrawing": "Replace the drawing",
    "replaceIntro": "Upload a new drawing, or use one you have checked. It is checked again; earlier versions are kept.",
    "fromCheck": "Use a drawing you checked",
    "uploadInstead": "No, upload a file",
    "checkNewDrawing": "Check the new drawing",
    "cancel": "Cancel",
    "fields": {
      "PLOT_AREA": "Plot area (m²)",
      "NET_PLOT_AREA": "Net plot area (m²)",
      "FOOTPRINT_AREA": "Building footprint (m²)",
      "TOTAL_BUA": "Total built-up area (m²)",
      "BUILDING_HEIGHT": "Building height (m)",
      "CAR_BAYS": "Car parking bays",
      "TWO_WHEELER_BAYS": "Two-wheeler parking bays"
    },
    "sources": {
      "DRAWING": "From the drawing",
      "ARCHITECT": "Declared by the architect",
      "MANUAL_VERIFICATION": "Not measured: to be checked by hand"
    },
    "values": {
      "title": "Values in the application",
      "intro": "Taken from the drawing. If a value is wrong, declare the right one and say why; the officer sees both.",
      "item": "Item",
      "measured": "Measured",
      "value": "In the application",
      "source": "Where it comes from",
      "actions": "Change",
      "because": "Reason: {{reason}}",
      "declare": "Declare a different {{item}}",
      "useMeasured": "Use the measured {{item}}",
      "declaring": "A different value for {{item}}",
      "newValue": "Value",
      "reason": "Why it differs from the drawing",
      "save": "Save the value",
      "valueInvalid": "Enter a number of 0 or more.",
      "reasonRequired": "Say why the value differs from the drawing."
    },
    "revokedTitle": "The approval was revoked",
    "revokedBody": "An officer withdrew the approval. Its QR code now shows it as revoked.",
    "search": "Search by number, owner or site",
    "allStatuses": "Every status",
    "columns": {
      "problems": "Problems"
    }
  },
  "comments": {
    "title": "Comments",
    "none": "No comments yet.",
    "meta": "{{author}} · {{date}} · version {{revision}}",
    "show": "Show comment {{number}} on the drawing",
    "new": "New comment",
    "newHint": "To place it on the drawing, choose Place a comment above the drawing and click the spot.",
    "bodyRequired": "Write the comment.",
    "placed": "Placed on the drawing at {{x}}, {{y}}",
    "notPlaced": "Not placed on the drawing",
    "unplace": "Remove the place",
    "add": "Add the comment"
  },
  "decision": {
    "title": "Decision",
    "action": "Your decision",
    "actions": {
      "RETURN": "Return for changes",
      "REJECT": "Reject",
      "APPROVE": "Approve"
    },
    "explain": {
      "RETURN": "The architect can change the drawing and the form, and submit again.",
      "REJECT": "Final. Needs the zone and use confirmed.",
      "APPROVE": "Needs the zone and use confirmed, and each limitation checked by you."
    },
    "limitations": "What automated scrutiny doesn't cover",
    "limitationsIntro": "Confirm that you have checked each of these yourself.",
    "remark": "Remark",
    "remarkHint": "The architect sees this. For a return, say what to change.",
    "chooseAction": "Choose return, reject or approve.",
    "remarkRequired": "Write a remark.",
    "zoneFirst": "Confirm the zone and use first.",
    "confirmAll": "Confirm every limitation before approving.",
    "submit": {
      "RETURN": "Return the application",
      "REJECT": "Reject the application",
      "APPROVE": "Approve the application"
    },
    "submitAny": "Record the decision",
    "done": {
      "RETURN": "Returned by {{officer}} (version {{revision}})",
      "REJECT": "Rejected by {{officer}} (version {{revision}})",
      "APPROVE": "Approved by {{officer}} (version {{revision}})",
      "REVOKE": "Approval revoked by {{officer}} (version {{revision}})",
      "APPROVE_AUTOMATIC": "Approved automatically (version {{revision}})",
      "RETURN_AUTOMATIC": "Returned automatically (version {{revision}})"
    }
  },
  "history": {
    "title": "History",
    "none": "Nothing recorded yet.",
    "actions": {
      "created": "Draft started",
      "updated": "Details changed",
      "drawing_attached": "New drawing added",
      "drawing_edited": "Drawing fixed on screen",
      "submitted": "Submitted",
      "review_started": "Review started",
      "commented": "Comment added",
      "zone_confirmed": "Zone and use confirmed",
      "returned": "Returned for changes",
      "rejected": "Rejected",
      "approved": "Approved",
      "revoked": "Approval revoked",
      "revision_started": "Revision of the approved drawing started",
      "approval": {
        "issued": "Approved drawing issued",
        "failed": "The approved drawing couldn't be prepared"
      }
    }
  },
  "review": {
    "queueTitle": "Applications to review",
    "queueIntro": "Every application submitted to your authority. Filter to find the ones you need.",
    "filters": "Filters",
    "status": "Status",
    "waiting": "Waiting for review",
    "anyStatus": "Any status",
    "severity": "Problems",
    "anySeverity": "Any",
    "withErrors": "With errors",
    "warningsOnly": "Warnings only",
    "noProblems": "No problems",
    "anyZone": "Any zone",
    "architect": "Architect",
    "anyArchitect": "Any architect",
    "from": "Submitted from",
    "to": "Submitted until",
    "clear": "Clear the filters",
    "emptyTitle": "No applications match",
    "emptyBody": "Change or clear the filters.",
    "showing": "Showing {{from}}–{{to}} of {{total}}",
    "application": "Application",
    "problems": "Problems",
    "submitted": "Submitted",
    "pages": "Pages",
    "previous": "Previous",
    "next": "Next",
    "backToQueue": "Back to the queue",
    "title": "Review of {{name}}",
    "start": "Start the review",
    "startHint": "Marks the application as under review by you.",
    "overridesNote_one": "The architect declared {{count}} value instead of the measured one. Check the reason below.",
    "overridesNote_other": "The architect declared {{count}} values instead of the measured ones. Check the reasons below.",
    "zoneTitle": "Zone and use",
    "zoneIntro": "The architect gave zone {{zone}} and use {{use}}. Confirm them, or correct them from the master plan.",
    "zoneConfirmed": "Confirmed: zone {{zone}}, use {{use}}, by {{officer}}",
    "zoneChangedFrom": "Changed from zone {{zone}}, use {{use}}.",
    "becauseReason": "Reason: {{reason}}",
    "changeReason": "Why the zone or use is different",
    "changeReasonHint": "The architect sees this.",
    "reasonRequired": "Say why you changed the zone or use.",
    "confirmZone": "Confirm the zone and use",
    "confirmChanged": "Correct the zone and use, and check the bylaws again",
    "zoneChangedNote": "Results for zone {{zone}} and use {{use}}, as confirmed by {{officer}}.",
    "search": "Search"
  },
  "people": {
    "title": "People",
    "intro": "Everyone who works for your authority, with their role. New people sign in with a one-time password and choose their own.",
    "add": "Add a person",
    "addIntro": "If the person already has an account with another authority, they are added with their existing account and password.",
    "fullName": "Full name",
    "role": "Role",
    "addSubmit": "Add them",
    "addInvalid": "Enter the name and a valid email address.",
    "addedExisting": "{{name}} is added",
    "addedExistingBody": "They already had an account, so they sign in with their own password.",
    "search": "Search by name or email",
    "anyRole": "Any role",
    "active": "Active",
    "inactive": "Switched off",
    "locked": "Locked after failed sign-ins",
    "none": "No one matches.",
    "you": "you",
    "lastSignIn": "Last signed in {{date}}",
    "neverSignedIn": "Has not signed in yet",
    "codesOn": "Sign-in codes on",
    "shared": "Also works for another authority",
    "deactivate": "Switch off",
    "reactivate": "Switch on again",
    "resetPassword": "New one-time password",
    "resetCodes": "Reset sign-in codes",
    "unlock": "Unlock",
    "confirmResetPassword": "Give {{name}} a new one-time password? Their current password stops working and they are signed out.",
    "confirmResetCodes": "Reset {{name}}'s sign-in codes? They set them up again at their next sign-in.",
    "confirmUnlock": "Unlock {{name}}'s account now?",
    "done": {
      "reset-mfa": "Sign-in codes reset. They set them up again at their next sign-in.",
      "unlock": "The account is unlocked."
    },
    "otpTitle": "One-time password for {{name}}",
    "otpBody": "Give it to them in person or by phone, not by email. They choose their own password when they sign in. It won't be shown again.",
    "copyPassword": "Copy the password",
    "otpDone": "I've given it to them",
    "roleOf": "Role of {{name}}",
    "roleChanged": "{{name}}'s role is changed",
    "actionsFor": "More for {{name}}",
    "columns": {
      "person": "Person",
      "lastSignIn": "Last signed in"
    }
  },
  "reference": {
    "title": "Zones and uses",
    "intro": "What architects choose from, and what bylaw rows refer to. Codes can't change; switch an entry off instead of deleting it.",
    "code": "Code",
    "name": "Name",
    "save": "Save",
    "rename": "Rename {{code}}",
    "switchOff": "Switch {{code}} off",
    "switchOn": "Switch {{code}} on",
    "invalid": "Use a code of 1 to 32 capital letters, digits, - or _, and give a name.",
    "zones": {
      "title": "Zones",
      "intro": "Land-use zones of the master plan.",
      "none": "No zones yet.",
      "add": "Add the zone"
    },
    "uses": {
      "title": "Building uses",
      "intro": "Residential, commercial, institutional and so on.",
      "none": "No uses yet.",
      "add": "Add the use"
    }
  },
  "ruleSets": {
    "title": "Bylaws",
    "intro": "Your authority's bylaw limits, as rule sets. Change a draft, check it and publish it; the published set is used for every check from its date. Only one set is in force at a time: the published one with the latest date (the one published last, if two share it); the earlier ones are replaced. A published set never changes: start a new version to correct it.",
    "status": {
      "DRAFT": "Draft",
      "PUBLISHED": "Published",
      "RETIRED": "Retired"
    },
    "standing": {
      "IN_FORCE": "In force",
      "REPLACED": "Replaced",
      "SCHEDULED": "From {{date}}"
    },
    "none": "No rule sets yet",
    "noneBody": "Start one below, copy another authority's from the library, or import a file.",
    "rules_one": "{{count}} rule",
    "rules_other": "{{count}} rules",
    "from": "From {{date}}",
    "noDate": "No start date",
    "new": "Start a new rule set",
    "name": "Name",
    "nameHint": "For example: Assam Building Bylaws 2024.",
    "version": "Version",
    "versionHint": "For example: 2024.1. A name and version can be used once.",
    "effectiveFrom": "In force from",
    "startFrom": "Start from",
    "empty": "An empty rule set",
    "copyOf": "A copy of {{name}} · {{version}}",
    "create": "Create the draft",
    "nameVersionRequired": "Give a name and a version.",
    "import": "Import from a file",
    "importIntro": "A rule set exported from this platform, as a .json file. It becomes a draft here.",
    "importFile": "Rule-set file",
    "importInvalid": "This isn't a rule-set file exported from this platform.",
    "importReady": "{{file}}: {{name}} · {{version}}, {{count}} rows.",
    "createMissing": "Add any zones and uses in the file that this authority doesn't have yet",
    "importSubmit": "Import as a draft",
    "library": "Copy from another authority",
    "libraryIntro": "Published rule sets of every authority. Authorities under the same state bylaws enter the numbers once and copy them.",
    "stateCode": "State code",
    "libraryEmpty": "No published rule sets to copy.",
    "libraryFrom": "{{authority}} ({{state}}) · {{count}} rows",
    "copyIntoDraft": "Copy {{name}} into a new draft",
    "copying": "Copying…",
    "backToList": "All rule sets",
    "readOnly": "This rule set can't be changed. To correct it, start a new version as a copy of it.",
    "changeDetails": "Change the name, version or date",
    "saved": "Saved.",
    "check": "Check before publishing",
    "publishable": "Ready to publish",
    "publishIntro": "Once published, it is used for every check from its start date, and the rule set in force before it is retired.",
    "notPublishable": "Fix these before publishing",
    "publish": "Publish",
    "confirmPublish": "Publish {{name}}? It can't be changed afterwards.",
    "retire": "Retire",
    "confirmRetire": "Retire {{name}}? Checks will have no bylaws until another set is published.",
    "delete": "Delete the draft",
    "confirmDelete": "Delete the draft {{name}}? This can't be undone.",
    "export": "Download as a file",
    "compare": "Compare with another rule set",
    "compareWith": "Compare with",
    "compareSummary": "{{added}} rows only here, {{removed}} only there, {{changed}} changed, {{same}} the same.",
    "onlyHere": "Only here: {{type}}, {{zone}}, {{use}}",
    "onlyThere": "Only there: {{type}}, {{zone}}, {{use}}",
    "changedRow": "Changed: {{type}}, {{zone}}, {{use}}",
    "noRules": "No rows yet. Add the first one.",
    "publishedAt": "Published {{date}}",
    "retiredAt": "Retired {{date}}",
    "columns": {
      "ruleSet": "Rule set",
      "rules": "Rows"
    }
  },
  "rules": {
    "add": "Add a row",
    "addTitle": "New row",
    "editTitle": "Change the row",
    "edit": "Change this row",
    "remove": "Remove this row",
    "confirmRemove": "Remove this row?",
    "type": "What it checks",
    "appliesTo": "Applies to",
    "anyZone": "Any zone",
    "anyUse": "Any use",
    "zoneIs": "Zone {{zone}}",
    "useIs": "Use {{use}}",
    "limits": "Limits",
    "optional": "{{label}} (optional)",
    "roomLabel": "Room",
    "roomLabelHint": "The room label as written in drawings.",
    "reference": "Bylaw reference",
    "referenceHint": "The clause or table it comes from, such as Table 5, row 3.",
    "provisional": "Provisional: not yet verified by the department",
    "provisionalHint": "Its results are shown but measured only: they never pass or fail a drawing. Clear it once the department has verified the values.",
    "provisionalTag": "Provisional",
    "notes": "Notes",
    "save": "Save the row",
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "problems": {
      "required": "Enter a value.",
      "number": "Enter a number, like 1.75.",
      "integer": "Enter a whole number.",
      "above": "Enter a number above {{min}}.",
      "atLeast": "Enter {{min}} or more.",
      "atMost": "Enter {{max}} or less.",
      "room": "Choose the room."
    },
    "flags": {
      "withinUlb": "Plot within a ULB area",
      "ewsLig": "EWS/LIG housing",
      "withinUlbIs": "Within a ULB area: {{answer}}",
      "ewsLigIs": "EWS/LIG housing: {{answer}}",
      "any": "Either answer",
      "yes": "Yes",
      "no": "No"
    },
    "bands": {
      "title": "Only for some plots (optional)",
      "intro": "Leave empty to apply to every plot. Bylaw tables often differ by plot size or road width: \"above 125 up to 200\" leaves 125 out and takes 200 in.",
      "plotArea": "Plot area (m²)",
      "netPlotArea": "Net plot area (m²)",
      "roadWidth": "Road width (m)",
      "proposedRoadWidth": "Road width once widened (m)",
      "buildingHeight": "Building height (m)",
      "floors": "Floors above ground (the ground and a stilt floor counted)",
      "from": "From",
      "to": "Up to",
      "includeFrom": "Including this value",
      "includeTo": "Including this value",
      "invalid": "Check the numbers for {{band}}: the start must not be above the end.",
      "fromIncl": "from {{value}}",
      "above": "above {{value}}",
      "upTo": "up to {{value}}",
      "below": "below {{value}}"
    },
    "types": {
      "FAR_MAX": "Floor area ratio (FAR)",
      "COVERAGE_MAX": "Ground coverage",
      "SETBACK_MIN": "Setbacks",
      "HEIGHT_MAX": "Building height",
      "PARKING_MIN": "Parking",
      "BALCONY_CAP": "Balcony allowance",
      "ROOM_MIN": "Room sizes",
      "PLOT_AREA_RANGE": "Plot size",
      "PLOT_FRONTAGE_MIN": "Plot frontage",
      "PLOT_WIDTH_MIN": "Plot width",
      "CUPBOARD_CAP": "Cantilever cupboard allowance",
      "CUPBOARD_LIMITS": "Cantilever cupboard depth and length",
      "FLOORS_MAX": "Number of floors",
      "ROAD_WIDTH_MIN": "Road width",
      "STAIR_MIN": "General stair",
      "FIRE_STAIR_MIN": "Fire stair",
      "LIFT_MIN": "Lifts",
      "LOBBY_WIDTH_MIN": "Lobby width",
      "BALCONY_LIMITS": "Balcony width and distance",
      "RWH_MIN": "Rain-water harvesting",
      "SEPTIC_TANK_MIN": "Septic tank",
      "RECREATIONAL_MIN": "Recreational space",
      "ROOF_STRUCTURE_MAX": "Roof structures",
      "MEZZANINE_MAX": "Mezzanine",
      "PLINTH_HEIGHT": "Plinth height",
      "FLOOR_HEIGHT": "Floor height",
      "AUTO_APPROVAL": "Automatic approval"
    },
    "explain": {
      "FAR_MAX": "The most floor area allowed for the plot area. Exempt areas are left out of the floor area.",
      "COVERAGE_MAX": "The largest share of the plot the building may cover.",
      "SETBACK_MIN": "The smallest open space between the building and each side of the plot.",
      "HEIGHT_MAX": "The tallest building allowed: a fixed height, or a multiple of the road width.",
      "PARKING_MIN": "Bays required for the floor area, and never fewer than the minimum.",
      "BALCONY_CAP": "How much balcony area is left out of the floor area on each floor.",
      "ROOM_MIN": "The smallest area and width for a kind of room.",
      "PLOT_AREA_RANGE": "The smallest and largest plot allowed.",
      "PLOT_FRONTAGE_MIN": "The shortest plot edge along the road.",
      "PLOT_WIDTH_MIN": "The narrowest plot, as its average width dimension gives it.",
      "CUPBOARD_CAP": "How much of the cantilever cupboards (wardrobes drawn as balconies, with WARDROBE written in them) is left out of the floor area on each floor; the rest counts in it.",
      "CUPBOARD_LIMITS": "The deepest a cantilever cupboard may project, and the longest the cupboards beside one habitable room may be together.",
      "FLOORS_MAX": "The most floors above ground.",
      "ROAD_WIDTH_MIN": "The narrowest road the plot may face.",
      "STAIR_MIN": "Each general stair flight's width, tread and risers, each mid landing's width, and the riser height, as drawn on the stair's flight and landing layers.",
      "FIRE_STAIR_MIN": "The same limits for fire stairs.",
      "LIFT_MIN": "The fewest lifts in each block, and the smallest lift car. Use a building-height band to require lifts only above a height.",
      "LOBBY_WIDTH_MIN": "The narrowest lobby.",
      "BALCONY_LIMITS": "The widest a balcony may project, and the least distance from the balconies to the plot boundary.",
      "RWH_MIN": "The smallest rain-water tank, and the percolation pits: one for so much plot area, and never fewer than the minimum.",
      "SEPTIC_TANK_MIN": "The smallest septic tank.",
      "RECREATIONAL_MIN": "The least landscaping and organised open space, each as a share of the plot.",
      "ROOF_STRUCTURE_MAX": "The tallest stair cover (mumty), roof tank, chimney and parapet.",
      "MEZZANINE_MAX": "The largest mezzanine, as a share of the plinth area. No more is allowed even where FAR is left.",
      "PLINTH_HEIGHT": "The lowest and highest plinth above the ground level of the plot.",
      "FLOOR_HEIGHT": "The lowest height of each floor above ground, a stilt floor too, and the highest parking floor, as the section dimensions them (floor to floor).",
      "AUTO_APPROVAL": "Applications within these limits that pass every check are approved without an officer's review. It raises no problem of its own."
    },
    "params": {
      "maxFar": "Largest FAR",
      "exemptCategories": "Left out of the floor area",
      "maxCoveragePercent": "Largest coverage (%)",
      "minFront": "Front setback, smallest (m)",
      "minRear": "Rear setback, smallest (m)",
      "minSide": "Side setback, smallest (m)",
      "roadWideningShare": "Front setback grows by this share of the road's widening (0 to 1)",
      "maxHeight": "Tallest height (m)",
      "roadWidthMultiplier": "Times the road width",
      "addFrontSetback": "Add the front setback to the height allowed",
      "useProposedRoadWidth": "Use the road once widened (the front setback from the new street line)",
      "basis": "Counted from",
      "areaPerCarBay": "Floor area per car bay (m²)",
      "areaPerTwoWheelerBay": "Floor area per two-wheeler bay (m²)",
      "minCarBays": "Fewest car bays",
      "minTwoWheelerBays": "Fewest two-wheeler bays",
      "rounding": "Rounding of bays",
      "maxPercentOfFloorBua": "Largest balcony share of the floor (%)",
      "maxAreaPerFloor": "Largest balcony area per floor (m²)",
      "minArea": "Smallest area (m²)",
      "minWidth": "Smallest width (m)",
      "maxArea": "Largest area (m²)",
      "minFrontage": "Shortest frontage (m)",
      "minPlotWidth": "Narrowest plot (m)",
      "maxFloors": "Most floors",
      "countStilt": "Count a stilt floor",
      "minRoadWidth": "Narrowest road (m)",
      "maxPlotArea": "Largest plot area (m²)",
      "maxBuildingHeight": "Tallest building (m)",
      "maxTotalBua": "Largest total built-up area (m²)",
      "measure": "Height compared",
      "addChimneyAbove": "Add a chimney taller than (m) to the height",
      "addRoofTankAbove": "Add a roof tank taller than (m) to the height",
      "addMumtyAbove": "Add a stair cover (mumty) taller than (m) to the height",
      "minFlightWidth": "Narrowest flight (m)",
      "minLandingWidth": "Narrowest mid landing (m)",
      "maxRiserHeight": "Highest riser (m)",
      "minTread": "Shallowest tread (m)",
      "maxRisersPerFlight": "Most risers in a flight",
      "minLifts": "Fewest lifts in a block",
      "minCarWidth": "Narrowest lift car (m)",
      "minCarDepth": "Shallowest lift car (m)",
      "requiredAboveHeight": "Lifts required above this height (m)",
      "requiredAboveFloors": "…or above this many floors, the ground and a stilt floor included",
      "maxWidth": "Widest (m)",
      "minBoundaryDistance": "Least distance to the plot boundary (m)",
      "minCapacityLitres": "Smallest capacity (litres)",
      "plotAreaPerPit": "One percolation pit for each (m² of plot)",
      "minPits": "Fewest percolation pits",
      "minLandscapingPercent": "Least landscaping (% of the plot)",
      "minOrganisedOpenSpacePercent": "Least organised open space (% of the plot)",
      "maxMumtyHeight": "Tallest stair cover (m)",
      "maxRoofTankHeight": "Tallest roof tank (m)",
      "maxChimneyHeight": "Tallest chimney (m)",
      "maxParapetHeight": "Tallest parapet (m)",
      "lobbyCapPerStairOrLift": "Lobby left out, per staircase or lift on the floor (m²)",
      "corridorCapPerStair": "Corridors left out, per staircase on the floor (m²)",
      "mezzanineCapPercentOfPlinth": "Mezzanine left out, up to (% of the plinth)",
      "basementCountedOccupancies": "Basements of these occupancies count",
      "exemptionCapPercent": "All exemptions together, up to (% of the permissible FAR area)",
      "exemptionCapCategories": "Exemptions within that limit",
      "maxLengthShare": "Balconies left out along (share of the building's length, 0 to 1)",
      "lengthSharePerSide": "That share of each side of the building, for the balconies on that side",
      "upperFloorsOnly": "Upper floors only (ground, stilt and basement floors count in full)",
      "maxPercentOfFloorArea": "Largest share of the floor's built-up area (%)",
      "maxDepth": "Deepest projection (m)",
      "maxLengthPerHabitableRoom": "Longest beside one habitable room, together (m)",
      "maxPercentOfPlinth": "Largest mezzanine (% of the plinth)",
      "omitParkingFloorUpTo": "Ground-level parking floor left out of the height, up to (m)",
      "parkingFloorMinShare": "A ground floor is a parking floor when parking and its stairs and lifts cover at least (share, 0 to 1)",
      "maxFrontSetbackAdded": "Front setback added, up to (m)",
      "appliesAboveFloors": "Only for buildings with more floors above ground than",
      "minPlinthHeight": "Lowest plinth (m)",
      "maxPlinthHeight": "Highest plinth (m)",
      "minFloorHeight": "Lowest floor height (m)",
      "maxParkingFloorHeight": "Highest parking floor (m)",
      "parkingFloorAppliesAboveFloors": "Parking floor limit only for buildings with more floors above ground than"
    },
    "options": {
      "BALCONY": "Balconies",
      "CUPBOARD": "Cantilever cupboards",
      "STAIRCASE": "Staircases",
      "LIFT": "Lifts",
      "DUCT": "Ducts",
      "PARKING": "Parking, including stilt floors",
      "TOTAL_BUA": "Total built-up area",
      "FAR_AREA": "Floor area counted for FAR",
      "PLOT": "The plot as drawn",
      "NET_PLOT": "The plot after road widening",
      "UP": "Up",
      "HALF_UP": "To the nearest (half up)",
      "DOWN": "Down",
      "LOBBY": "Lobbies",
      "CORRIDOR": "Corridors",
      "DEDUCTION": "Deductions drawn on the plan",
      "MEZZANINE": "Mezzanines",
      "BASEMENT": "Basements",
      "TOTAL": "The full height",
      "EXCLUDING_MACHINE_ROOM": "The height without the machine room",
      "PLINTH_AND_FLOORS": "The plinth and every floor's height added up"
    },
    "rooms": {
      "BATH": "Bathroom",
      "BEDROOM": "Bedroom",
      "DINING": "Dining room",
      "KITCHEN": "Kitchen",
      "LIVING": "Living room",
      "POOJA": "Pooja room",
      "STORE": "Store room",
      "STUDY": "Study",
      "TOILET": "Toilet",
      "WC": "WC",
      "GENERAL ROOM": "General room",
      "CLASSROOM": "Classroom",
      "SHOP": "Shop",
      "ACCESSIBLE WC": "Accessible WC"
    }
  },
  "authorities": {
    "title": "Authorities",
    "intro": "Each authority has its own zones, bylaws, application numbers and people. Create one, set its settings, and give it its first administrator.",
    "anyState": "Every state",
    "none": "No authorities yet.",
    "add": "Add an authority",
    "code": "Code",
    "codeHint": "Short, for example GMDA. It can't change.",
    "state": "State",
    "create": "Create the authority",
    "invalid": "Give a code of 2 to 32 letters or digits, a name and the state.",
    "numberPrefix": "Application number prefix",
    "numberPrefixHint": "Numbers read PREFIX-2026-000001.",
    "prefixInvalid": "Use 1 to 10 capital letters or digits for the prefix.",
    "dailyLimit": "Checks per architect per day",
    "dailyLimitHint": "Keeps the queue free for real submissions.",
    "limitInvalid": "Enter a whole number from 1 to 10000 for the daily checks.",
    "twoPerson": "A second administrator must publish bylaw changes",
    "status": "Status",
    "settings": "Settings",
    "settingsIntro": "Your authority's settings. You choose who decides applications; a platform administrator changes the others.",
    "admins": "Administrators",
    "adminsIntro": "Administrators add the authority's people and keep its bylaws. Add the first one here.",
    "noAdmins": "No administrator yet. Add one so the authority can be set up.",
    "addAdmin": "Add the administrator",
    "backToList": "All authorities",
    "deactivate": "Switch the authority off",
    "reactivate": "Switch the authority on",
    "deactivateIntro": "Switched off, nobody can work for it; its records are kept.",
    "reactivateIntro": "Its people can work for it again.",
    "confirmDeactivate": "Switch {{name}} off? Nobody can work for it until it is switched on again.",
    "confirmReactivate": "Switch {{name}} on again?",
    "approvalMode": "Approval",
    "approvalModeHint": "Automatic approval issues the approved drawing at once when a submission meets every condition. The rest go to officers, or, with no officers, back to the architect.",
    "modes": {
      "AUTOMATIC": "Automatic, when every condition is met",
      "OFFICER": "By an officer",
      "AUTOMATIC_ONLY": "Automatic only, with no officers"
    },
    "officerReview": "Who decides applications",
    "officerReviewIntro": "An application that passes every automatic check can be approved at once, with its signed drawing and QR code. Choose whether officers review the others, or every application.",
    "reviewModes": {
      "OFFICER": "An officer decides every application",
      "AUTOMATIC": "Approve automatically; officers decide the rest",
      "AUTOMATIC_ONLY": "Approve automatically; no officers"
    },
    "reviewExplain": {
      "OFFICER": "Every submitted application waits in the officers' queue.",
      "AUTOMATIC": "An application that passes every check is approved at once. One that doesn't goes to the officers' queue, with the reasons.",
      "AUTOMATIC_ONLY": "An application that passes every check is approved at once. One that doesn't goes back to the architect at once, with the reasons, to change and submit again. Officers aren't needed."
    },
    "noOfficersWarning": "With no officers, nobody looks at what automated scrutiny can't check (fire safety, structure, other approvals), and an application outside your limits for automatic approval, or submitted while no bylaw rules are in force, can't be approved: it goes back to the architect. Applications already waiting for an officer stay in the queue.",
    "officerReviewSaved": "Saved. Applications submitted from now on are decided this way.",
    "validity": "Approval valid for (months)",
    "validityHint": "How long an approved drawing stays valid.",
    "validityInvalid": "Enter a whole number of months from 1 to 240.",
    "search": "Search authorities",
    "noOfficersWithKnowledgeBase": "Not while the byelaws knowledge base is on: what it can't decide needs an officer."
  },
  "statesPage": {
    "title": "States",
    "intro": "The states this platform serves. Open one to see its authorities.",
    "codeHint": "The 2-letter code, such as AS.",
    "invalid": "Give the 2- or 3-letter state code and its name.",
    "add": "Add the state"
  },
  "accounts": {
    "title": "Accounts",
    "intro": "One account for each person, whichever authorities they work for.",
    "show": "Show",
    "all": "Everyone",
    "platformAdmins": "Platform administrators",
    "backToList": "All accounts",
    "memberships": "Works for",
    "noMemberships": "No authority yet.",
    "actions": "Account",
    "self": "You can't change your own account here.",
    "makeAdmin": "Make a platform administrator",
    "removeAdmin": "Remove platform administrator",
    "confirmMakeAdmin": "Make {{name}} a platform administrator? They can then change every authority and account.",
    "confirmRemoveAdmin": "Remove {{name}} as a platform administrator?",
    "confirmDeactivate": "Switch {{name}}'s account off? They are signed out everywhere.",
    "confirmReactivate": "Switch {{name}}'s account on again?"
  },
  "audit": {
    "title": "Activity log",
    "intro": "Everything done in your authority: who, what, when and from where. Entries can't be changed or removed.",
    "introPlatform": "Everything done on the platform, in every authority.",
    "action": "What happened",
    "anyAction": "Anything",
    "authority": "Authority",
    "anyAuthority": "Every authority",
    "target": "Record",
    "when": "When",
    "who": "Who",
    "from": "From address",
    "system": "The system",
    "details": "Details",
    "none": "Nothing matches.",
    "actions": {
      "auth_sign_in": "Signed in",
      "auth_sign_in_failed": "Sign-in failed",
      "auth_account_locked": "Account locked",
      "auth_sign_out": "Signed out",
      "auth_password_changed": "Password changed",
      "auth_password_accepted": "One-time password used",
      "auth_mfa_setup_started": "Sign-in codes set-up started",
      "auth_mfa_enabled": "Sign-in codes turned on",
      "auth_mfa_disabled": "Sign-in codes turned off",
      "auth_recovery_codes_replaced": "Recovery codes replaced",
      "auth_authority_selected": "Authority chosen",
      "user_created": "Account created",
      "user_updated": "Account changed",
      "user_password_reset": "One-time password given",
      "user_unlocked": "Account unlocked",
      "user_mfa_reset": "Sign-in codes reset",
      "user_platform_admin_changed": "Platform administrator changed",
      "membership_added": "Person added",
      "membership_updated": "Person's role or status changed",
      "zone_created": "Zone added",
      "zone_updated": "Zone changed",
      "use_created": "Use added",
      "use_updated": "Use changed",
      "rule_set_created": "Rule set started",
      "rule_set_updated": "Rule set changed",
      "rule_set_deleted": "Rule set deleted",
      "rule_set_published": "Rule set published",
      "rule_set_retired": "Rule set retired",
      "rule_added": "Bylaw row added",
      "rule_changed": "Bylaw row changed",
      "rule_removed": "Bylaw row removed",
      "upload_received": "Drawing uploaded",
      "pre_check_created": "Drawing checked",
      "pre_check_deleted": "Check deleted",
      "job_submitted": "Check started",
      "application_created": "Application started",
      "application_updated": "Application changed",
      "application_drawing_attached": "Drawing added to an application",
      "application_drawing_edited": "Application drawing fixed on screen",
      "application_submitted": "Application submitted",
      "application_review_started": "Review started",
      "application_commented": "Comment added",
      "application_zone_confirmed": "Zone and use confirmed",
      "application_returned": "Application returned",
      "application_rejected": "Application rejected",
      "application_approved": "Application approved",
      "state_created": "State added",
      "state_updated": "State changed",
      "authority_created": "Authority created",
      "authority_updated": "Authority changed",
      "application_revoked": "Approval revoked",
      "application_revision_started": "Revision of an approval started",
      "approval_issued": "Approved drawing issued",
      "approval_failed": "Approved drawing failed",
      "api_client_created": "BPA system added",
      "api_client_updated": "BPA system changed",
      "api_client_secret_changed": "BPA system's secret changed",
      "api_client_token_refused": "BPA system's sign-in refused",
      "webhook_created": "Webhook added",
      "webhook_updated": "Webhook changed",
      "webhook_deleted": "Webhook deleted",
      "licence_issued": "Desktop licence issued",
      "licence_revoked": "Desktop licence revoked",
      "licence_released": "Desktop licence released from its computer",
      "licence_activated": "Desktop licence activated",
      "licence_activation_refused": "Desktop licence activation refused",
      "golden_added": "Drawing added to the golden set",
      "golden_values_saved": "Golden set figures saved",
      "golden_signed": "Golden set figures signed",
      "golden_rechecked": "Golden set drawing checked again",
      "golden_retired": "Drawing taken out of the golden set",
      "golden_exported": "Golden set downloaded"
    },
    "page": "Page {{page}}"
  },
  "approval": {
    "title": "Approved drawing",
    "number": "Approval number",
    "approvedOn": "Approved on",
    "validUntil": "Valid until",
    "approvedBy": "Approved by",
    "automatically": "Automatically, by the authority's rules",
    "fingerprint": "File fingerprint (SHA-256)",
    "preparing": "The signed drawing is being prepared. This takes a minute.",
    "failed": "The approved drawing couldn't be prepared",
    "retry": "Try again",
    "download": "Download the signed drawing (PDF)",
    "verifyPage": "Open the verification page",
    "revise": "Revise the approved drawing",
    "confirmRevise": "Start a revision? The current approval stays valid until the revised one is approved.",
    "revoke": "Revoke the approval",
    "revokeIntro": "The QR code on every printed sheet will show the approval as revoked, at once.",
    "revokeRemark": "Why it is revoked",
    "revokeRemarkRequired": "Say why the approval is revoked.",
    "revokeSubmit": "Revoke the approval",
    "confirmRevoke": "Revoke this approval? This can't be undone.",
    "revokedOn": "Revoked on {{date}}",
    "earlier_one": "{{count}} earlier approval",
    "earlier_other": "{{count}} earlier approvals",
    "notAutomatic": "Why it wasn't approved automatically",
    "automaticMet": "Every condition of automatic approval was met",
    "met": "Met",
    "notMet": "Not met",
    "status": {
      "VALID": "Valid",
      "ISSUING": "Being prepared",
      "EXPIRED": "Expired",
      "SUPERSEDED": "Superseded",
      "REVOKED": "Revoked",
      "FAILED": "Couldn't be prepared"
    },
    "conditions": {
      "no_blocker_or_error": "The drawing has no errors",
      "every_bylaw_item_passes": "Every bylaw check passed",
      "rule_set_in_force": "Bylaws are in force",
      "no_declared_values": "No value was declared instead of the measured one",
      "nothing_for_manual_verification": "Nothing needs checking by hand",
      "within_automatic_limits": "Within the authority's limits for automatic approval",
      "approved_drawings_configured": "Approved drawings can be issued",
      "byelaw_knowledge_base_settled": "Nothing in the byelaw knowledge base fails or needs checking by a person"
    },
    "limitReasons": {
      "no_rule_set": "No bylaw rules are in force",
      "no_auto_approval_rule": "The bylaw rules set no limits for automatic approval",
      "ambiguous_rules": "More than one limit for automatic approval applies",
      "not_measured": "A figure the limits need couldn't be measured",
      "plot_area_above_limit": "The plot is larger than automatic approval allows",
      "height_above_limit": "The building is taller than automatic approval allows",
      "floors_above_limit": "The building has more floors than automatic approval allows",
      "total_bua_above_limit": "The built-up area is larger than automatic approval allows"
    }
  },
  "verification": {
    "title": "Verify an approved drawing",
    "noToken": "This link is incomplete",
    "notFound": "No approval matches this link",
    "notFoundBody": "Check that you scanned the QR code on the drawing, or typed the address exactly as printed. A drawing whose link doesn't open here isn't a genuine approved drawing.",
    "status": {
      "VALID": "Valid",
      "EXPIRED": "Expired",
      "REVOKED": "Revoked",
      "SUPERSEDED": "Superseded",
      "ISSUING": "Being prepared",
      "FAILED": "Not issued"
    },
    "explain": {
      "VALID": "This is a genuine approved drawing, valid until {{date}}.",
      "EXPIRED": "This drawing was approved, but the approval ended on {{date}}.",
      "REVOKED": "This approval was withdrawn by the authority. The drawing is no longer approved.",
      "SUPERSEDED": "A newer approved drawing replaces this one. Build to the current one.",
      "ISSUING": "The approval is recorded; its signed drawing is being prepared.",
      "FAILED": "The approval is recorded, but its drawing hasn't been issued yet."
    },
    "seeCurrent": "See the current approved drawing",
    "revokedOn": "Revoked on {{date}}",
    "approvalNumber": "Approval number",
    "applicationNumber": "Application number",
    "authority": "Approved by",
    "approvedOn": "Approved on",
    "validUntil": "Valid until",
    "approvedBy": "Signed by",
    "owner": "Owner",
    "site": "Site",
    "zoneUse": "Zone and use",
    "quantities": "Approved figures",
    "plotArea": "Plot area",
    "far": "Floor area ratio (FAR)",
    "coverage": "Ground coverage",
    "floors": "Floors",
    "totalBua": "Total built-up area",
    "height": "Building height",
    "setback": "Setback, {{side}}",
    "parking": "Parking",
    "sheets": "Sheets",
    "sheetAlt": "Sheet {{number}} of {{count}}",
    "download": "Download the signed drawing (PDF)",
    "fingerprint": "Check a copy",
    "checkFile": "Choose a PDF of the drawing",
    "checkFileHint": "The file is sent only to be compared, byte for byte, with the approved file. It isn't kept.",
    "checking": "Checking…",
    "matches": "This is the approved file",
    "matchesBody": "It is identical to the drawing that was approved.",
    "differs": "This file is not the approved one",
    "differsBody": "It differs from the approved drawing, even if it looks the same. Download the approved drawing above."
  },
  "integrations": {
    "title": "Integrations",
    "intro": "Connect your authority's BPA system: it checks drawings and submits applications through the API on behalf of your architects, and hears about decisions through webhooks.",
    "clients": "BPA systems",
    "clientsIntro": "Each system signs in with its client id and secret, and names the architect each request is made for. It can do what that architect can do, nothing more.",
    "noClients": "No systems yet.",
    "clientName": "System name",
    "clientNameHint": "For example: Assam BPA (production).",
    "addClient": "Add the system",
    "clientCreated": "The system's credentials",
    "clientId": "Client id",
    "clientSecret": "Client secret",
    "secretOnce": "Copy these into the other system's secure settings now. The secret is shown only once; if it is lost, make a new one.",
    "copy": "Copy the {{what}}",
    "stored": "I've stored them",
    "lastUsed": "Last signed in {{date}}",
    "neverUsed": "Not used yet",
    "newSecret": "Make a new secret",
    "confirmNewSecret": "Make a new secret for {{name}}? The old one stops working at once, and so does every token the system holds.",
    "webhooks": "Webhooks",
    "webhooksIntro": "Addresses the engine calls when something happens: a drawing checked, an application submitted or decided, an approved drawing issued. Each call is signed with the webhook's own secret and retried if it fails.",
    "noWebhooks": "No webhooks yet.",
    "addWebhook": "Add a webhook",
    "url": "Address",
    "urlHint": "An https:// address of your BPA system.",
    "eventsLabel": "Send these events",
    "webhookInvalid": "Give an https:// address and choose at least one event.",
    "addWebhookSubmit": "Add the webhook",
    "webhookCreated": "The webhook's signing secret",
    "signingSecret": "Signing secret",
    "lastDelivered": "Last delivered {{date}} ({{result}})",
    "lastFailed_one": "Failing: {{count}} delivery in a row, last {{date}} ({{result}})",
    "lastFailed_other": "Failing: {{count}} deliveries in a row, last {{date}} ({{result}})",
    "noDeliveries": "Nothing sent yet.",
    "deleteWebhook": "Delete the webhook to {{url}}",
    "confirmDelete": "Delete the webhook to {{url}}?",
    "events": {
      "drawing_checked": "A drawing was checked",
      "application_submitted": "An application was submitted",
      "application_approved": "An application was approved",
      "application_returned": "An application was returned",
      "application_rejected": "An application was rejected",
      "application_revoked": "An approval was revoked",
      "approval_issued": "An approved drawing was issued"
    }
  },
  "licences": {
    "title": "Desktop licences",
    "intro": "Architects of your authority need a licence key to use the desktop checker. They activate it once, on one computer. The program checks the licence with the server whenever it starts and before every check, so revoking a licence stops it at once.",
    "issue": "Issue a licence",
    "architect": "Architect",
    "chooseArchitectOption": "Choose an architect",
    "chooseArchitect": "Choose the architect the licence is for.",
    "endDate": "Last day (optional)",
    "endDateHint": "Leave empty for a licence that lasts until you revoke it.",
    "issueSubmit": "Issue the licence",
    "issued": "The licence key for {{holder}}",
    "key": "Licence key",
    "keyOnce": "Give this key to the architect now, by a safe route. It is shown only once; if it is lost, revoke the licence and issue a new one.",
    "list": "Licences",
    "none": "No licences yet.",
    "keyEnding": "Key ending {{hint}}",
    "status": {
      "ACTIVE": "Active",
      "EXPIRED": "Ended",
      "REVOKED": "Revoked"
    },
    "activatedOn": "Activated on {{machine}}, {{date}}",
    "notActivated": "Not activated on a computer yet.",
    "endsOn": "Last day {{date}}",
    "noEnd": "No end date",
    "lastUsed": "last used {{date}}",
    "revokedOn": "revoked {{date}}: {{reason}}",
    "release": "Release the computer",
    "confirmRelease": "Release the licence from {{machine}}? The program there stops at once, and the architect can activate the same key on another computer.",
    "revoke": "Revoke",
    "reason": "Why is it revoked?",
    "reasonHint": "Recorded in the activity log. {{name}} can no longer use the desktop checker.",
    "revokeConfirm": "Revoke the licence",
    "cancel": "Cancel"
  },
  "desktop": {
    "title": "Desktop checker",
    "intro": "Checks your drawings on this computer with your authority's rules. Drawings stay on this computer. The checker needs the internet to confirm your licence when it starts and before every check.",
    "banner": "Checked on this computer — not a submission. Submit through the web application, where the drawing is checked again.",
    "submitElsewhere": "This is a check on your computer, not a submission. To submit, upload the drawing in the web application; it is checked again there.",
    "held": "Licences on this computer",
    "holder": "{{name}} ({{email}})",
    "inUse": "In use",
    "rules": "rules {{version}}, downloaded {{date}}",
    "use": "Use this licence",
    "forget": "Remove the {{name}} licence from this computer",
    "confirmForget": "Remove the {{name}} licence from this computer? To use it here again, your authority must release it and you activate the key again.",
    "confirming": "Confirming your licence with the server…",
    "activate": "Activate a licence",
    "activateIntro": "Enter the licence key your authority gave you. It is activated for this computer ({{machine}}), once.",
    "keyHint": "It looks like SCR-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX.",
    "activateSubmit": "Activate",
    "nav": {
      "check": "Check a drawing",
      "licence": "Licence"
    }
  },
  "golden": {
    "title": "Golden set",
    "intro": "Real drawings whose figures an officer has checked by hand against the drawing. Every new version of the checking software must give the same figures before it is used.",
    "add": "Add a drawing",
    "addHint": "Choose a real drawing that was submitted to your authority. It is checked, then you compare each figure with the drawing.",
    "addSubmit": "Add to the golden set",
    "uploading": "Sending the drawing: {{percent}}%",
    "list": "Drawings in the golden set",
    "none": "No drawings yet",
    "noneHint": "Add a drawing here, or from an application you are reviewing.",
    "status": {
      "DRAFT": "Not signed",
      "VERIFIED": "Signed",
      "RETIRED": "Taken out"
    },
    "checking": "Being checked",
    "checkFailed": "The drawing couldn't be checked",
    "differs": "The latest check differs from the signed figures",
    "uploaded": "Uploaded",
    "fromApplication": "From an application (version {{number}})",
    "addedBy": "Added by {{name}} on {{date}}",
    "signedBy": "Signed by {{name}} on {{date}}",
    "engineVersion": "Checked with version {{version}} ({{standard}})",
    "back": "Back to the golden set",
    "figuresTitle": "Figures",
    "figuresHint": "Measure each figure on the drawing yourself. Where the check got it wrong, enter the right figure. Areas may differ by up to 0.1%.",
    "figuresAfterCheck": "The figures appear here once the drawing has been checked.",
    "noFigures": "This drawing has no figures to check.",
    "figure": "Figure",
    "engineValue": "Checked by the software",
    "checkedValue": "Checked by you",
    "checkedValueFor": "Your figure for {{figure}}",
    "match": "Same?",
    "matches": "Same",
    "differsBy": "Differs by {{percent}}%",
    "differsExact": "Differs",
    "noValue": "Enter a figure",
    "valuesInvalid": "Every figure must be a number of zero or more, and counts must be whole numbers.",
    "values": {
      "plotArea": "Plot area",
      "netPlotArea": "Net plot area",
      "footprintArea": "Footprint area",
      "height": "Building height",
      "floorCount": "Number of floors",
      "floorArea": "{{floor}}, building {{block}}: {{kind}}",
      "unnamedFloor": "Unnamed floor",
      "parking": "Parking spaces: {{kind}}"
    },
    "blockers": "Problems that stop the drawing being read",
    "blockersHint": "Tick every one this drawing really has, including any the software missed.",
    "foundByEngine": "found by the software",
    "notes": "Notes",
    "notesHint": "Anything the next person should know, such as why a figure was corrected.",
    "save": "Save figures",
    "saveFirst": "Save your changes before signing.",
    "sign": "Sign as checked",
    "signConfirm": "Sign to confirm you have checked every figure against the drawing. Signed figures are used to test every new version of the software.",
    "differencesTitle": "The latest check differs from these figures",
    "recheck": "Check again with the current software",
    "retire": "Take out of the golden set",
    "retireReason": "Reason",
    "retireHint": "The drawing is deleted from the golden set for good.",
    "retireConfirm": "Take it out",
    "cancel": "Cancel",
    "retiredTitle": "Taken out of the golden set",
    "retiredNoDrawing": "This drawing was taken out of the golden set and deleted.",
    "addFromApplication": "Add to the golden set",
    "addFromApplicationHint": "A copy of this drawing is kept so its figures can be checked by hand and used to test the software.",
    "platformTitle": "Golden set",
    "platformIntro": "Every authority's golden drawings. Download the signed ones before each release, to test the new version of the software.",
    "exportTitle": "Download for a release",
    "exportStep1": "Download the signed drawings and their figures.",
    "exportStep2": "On the release machine, put the drawings in the golden folder and the figures in the repository.",
    "exportStep3": "Run the golden-set test. The runbook has the steps.",
    "export_one": "Download {{count}} signed drawing",
    "export_other": "Download {{count}} signed drawings",
    "exportNone": "No drawing has been signed yet.",
    "allTitle": "All golden drawings",
    "noneAnywhere": "No authority has added a golden drawing yet."
  },
  "navGroups": {
    "overview": "Overview",
    "work": "Work",
    "people": "People and access",
    "bylaws": "Bylaws and quality",
    "authority": "Authority",
    "platform": "Platform",
    "guides": "Guides"
  },
  "ui": {
    "close": "Close",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "dismiss": "Dismiss",
    "notifications": "Notifications",
    "search": "Search",
    "columns": "Columns",
    "noMatches": "Nothing matches.",
    "pages": "Pages",
    "pageOf": "Page {{page}} of {{pageCount}} · {{total}} in all",
    "previous": "Previous",
    "next": "Next",
    "breadcrumbs": "You are here",
    "openMenu": "Open the menu",
    "collapseMenu": "Collapse the menu",
    "expandMenu": "Expand the menu",
    "saved": "Saved",
    "failed": "That didn't work"
  },
  "command": {
    "label": "Search pages and actions",
    "open": "Search pages, applications and actions (Ctrl+K)",
    "search": "Search…",
    "placeholder": "Search pages and actions…",
    "placeholderApplications": "Search applications, pages and actions…",
    "empty": "Nothing found.",
    "applications": "Applications",
    "actions": "Actions",
    "draft": "Draft",
    "theme": "Colour theme: {{theme}}"
  },
  "dashboard": {
    "figures": "Figures",
    "monthly": "Applications per month",
    "monthlyIntro": "Submitted, and decided as approved, returned or rejected, in the last six months.",
    "monthlySummary": "Bar chart of applications submitted and decided in each of the last six months; the figures are in the table that follows.",
    "month": "Month",
    "series": {
      "submitted": "Submitted",
      "approved": "Approved",
      "returned": "Returned",
      "rejected": "Rejected"
    },
    "byStatus": "By status",
    "byStatusMine": "Your applications as they stand.",
    "byStatusAll": "The authority's applications as they stand.",
    "statusSummary": "Ring chart of {{total}} applications by status; the figures are listed beside it.",
    "total": "in all",
    "recentTitle": "Your latest applications",
    "waitingTitle": "Waiting for review",
    "seeAll": "See all",
    "noneYet": "No applications yet.",
    "noneWaiting": "Nothing is waiting for review.",
    "lessThanADay": "Under a day",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days",
    "columns": {
      "application": "Application",
      "site": "Site",
      "status": "Status",
      "updated": "Last change"
    },
    "figure": {
      "preChecks": "Drawing checks",
      "drafts": "Drafts",
      "inReview": "With the authority",
      "returned": "Returned to you",
      "approved": "Approved",
      "waiting": "Waiting for review",
      "underReview": "Under review",
      "decidedThisMonth": "Decided this month",
      "medianDaysToDecision": "Typical time to decide",
      "members": "People",
      "ruleSetsPublished": "Rule sets in force",
      "submittedThisMonth": "Submitted this month",
      "approvedThisMonth": "Approved this month",
      "states": "States",
      "authorities": "Authorities",
      "accounts": "Accounts",
      "applications": "Applications"
    },
    "note": {
      "preChecks": "Kept for 7 days",
      "inReview": "Submitted or under review",
      "medianDaysToDecision": "Median over the last 90 days",
      "members": "Active in this authority",
      "ruleSetsPublished": "Published and in use"
    }
  },
  "authLayout": {
    "headline": "Building plans checked against the bylaws, in minutes.",
    "check": "Upload a DXF drawing and see every problem on the drawing, with how to fix it.",
    "decide": "Submit when it passes; drawings that meet every rule can be approved at once.",
    "verify": "Every approved drawing carries a QR code anyone can check.",
    "footer": "Automated scrutiny supports, and does not replace, the authority's decision."
  },
  "knowledgeBase": {
    "title": "Byelaws knowledge base",
    "context": "{{name}}, build of {{build}}; checked as on {{date}} (amendments after it don't apply); {{regime}}.",
    "regimes": {
      "24_26": "Byelaws 24 and 26",
      "83": "Byelaw 83"
    },
    "regimeNotGiven": "regime not given",
    "rejectsTitle": "A verified byelaw isn't met",
    "rejects": "At least one byelaw that has been checked against the gazette fails. Fix the drawing before submitting.",
    "counts": "Results by outcome",
    "outcomes": {
      "PASS": "Compliant",
      "FAIL": "Non-compliant",
      "FAIL_PROVISIONAL": "Non-compliant, subject to verification",
      "MANUAL_REVIEW": "For an officer to check",
      "NOT_APPLICABLE": "Not applicable"
    },
    "provisional": "(provisional)",
    "provisionalCount_one": "{{count}} of these is provisional: its byelaw text is still being verified",
    "provisionalCount_other": "{{count}} of these are provisional: their byelaw text is still being verified",
    "decided": "Byelaws decided from the drawing",
    "noneDecided": "No byelaw could be decided from the drawing alone.",
    "rule": "Byelaw",
    "requirement": "Requirement",
    "permissible": "Permissible",
    "proposed": "Proposed",
    "status": "Status",
    "showAll": "Show every byelaw: {{manual}} for an officer to check, {{checklist}} on the officer's checklist",
    "loading": "Loading every byelaw…",
    "manualTitle": "For an officer to check",
    "manualIntro": "The drawing alone can't decide these. They are grouped by what an officer needs to look at.",
    "noReason": "No reason given",
    "ruleCount_one": "({{count}} byelaw)",
    "ruleCount_other": "({{count}} byelaws)",
    "checklistTitle": "Checklist for the scrutinising officer",
    "adminTitle": "Byelaws knowledge base",
    "adminIntro": "Also check every drawing against the state's byelaws, as a knowledge base of traceable rules, alongside your rule sets. A byelaw that has been verified and fails needs a fix; what the knowledge base can't decide goes to an officer.",
    "adminOn": "On: drawings are checked against the knowledge base.",
    "adminOff": "Off.",
    "adminWarning": "The knowledge base is incomplete: almost every drawing will have byelaws for an officer to check, so applications won't be approved automatically while it is on. Submissions already made keep their results.",
    "adminUnavailable": "There is no byelaw knowledge base for {{state}} yet.",
    "turnOn": "Turn on",
    "turnOff": "Turn off",
    "on": "On",
    "off": "Off",
    "adminNeedsOfficersTitle": "Choose who decides applications first",
    "adminNeedsOfficers": "Applications here are approved automatically with no officers, and what the knowledge base can't decide needs an officer. Under “Who decides applications” above, choose “An officer decides every application” or “Approve automatically; officers decide the rest” and save; then turn it on."
  },
  "scrutinyParameters": {
    "title": "Scrutiny parameters",
    "intro": "Choose, for each parameter, whether it must be accepted for a check to pass, or is measured only. A check passes when every parameter that must be accepted is accepted, and the drawing has no errors; a parameter that must be accepted but can't be checked for want of its value fails it. Measured-only parameters are reported with their value and limit, and never decide the result. Submitted applications keep the choice they were checked under.",
    "parameter": "Parameter",
    "choices": {
      "MUST_BE_ACCEPTED": "Must be accepted",
      "MEASURED_ONLY": "Measured only"
    },
    "changedFromDefault": "Changed (default: {{value}})",
    "save_one": "Save 1 change",
    "save_other": "Save {{count}} changes",
    "defaults": "Back to the defaults",
    "saved": "Saved. New checks use these choices.",
    "groups": {
      "Plot": "Plot",
      "FAR and coverage": "FAR and coverage",
      "Setbacks": "Setbacks",
      "Heights": "Heights",
      "Roof structures": "Roof structures",
      "Rooms": "Rooms",
      "Stairs and lifts": "Stairs and lifts",
      "Balconies and parking": "Balconies and parking",
      "Services": "Services"
    },
    "names": {
      "plot_area": "Plot area",
      "plot_width": "Plot width",
      "plot_frontage": "Plot frontage",
      "road_width": "Road width",
      "far": "FAR",
      "far_exemptions": "Areas exempted from FAR, within their cap",
      "balcony_allowance": "Balcony allowance (exempt from FAR)",
      "cupboard_allowance": "Cantilever cupboard allowance (exempt from FAR)",
      "mezzanine": "Mezzanine area",
      "coverage": "Ground coverage",
      "setback_front": "Front setback",
      "setback_rear": "Rear setback",
      "setback_side": "Side setbacks",
      "setback_existing": "Existing building's setbacks (to be regularised)",
      "height": "Building height",
      "floors": "Number of floors",
      "plinth_height": "Plinth height",
      "floor_height": "Floor height",
      "parking_floor_height": "Parking floor height",
      "roof_tank": "Roof tank (left out of the building height up to)",
      "stair_cover": "Stair cover (left out of the building height up to)",
      "chimney": "Chimney (left out of the building height up to)",
      "roof_structures": "Roof structures' largest heights (stair cover, roof tank, chimney, parapet)",
      "rooms": "Room sizes",
      "stairs": "General stair",
      "fire_stairs": "Fire stair",
      "lifts": "Lifts",
      "lobby": "Lobby width",
      "balcony_limits": "Balcony width and distance from the boundary",
      "cupboard_limits": "Cantilever cupboard depth and length beside a room",
      "parking": "Parking bays",
      "rwh": "Rain-water harvesting",
      "septic": "Septic tank",
      "recreational": "Recreational space"
    },
    "clauses": "Byelaws",
    "formulaItems_one": "1 formula",
    "formulaItems_other": "{{count}} formulas",
    "builtIn": "Built-in"
  },
  "formulas": {
    "title": "Formulas",
    "intro": "How each bylaw item is worked out for your authority. Every item uses the engine's own calculation until you write a formula: when its check applies, its proposed value from the drawing, or its permissible value. A saved formula is used by the next check at once; each change is in the Activity log, and each result records the formulas it used.",
    "editorIntro": "Write a formula over the measurements on the right. It is checked as you type; try it on a drawing before you save. Saved, it applies to your authority's next check.",
    "search": "Find an item",
    "onlyCustom": "Only items with formulas",
    "item": "Item",
    "byelaws": "Byelaws",
    "builtIn": "Built-in",
    "builtInLong": "Built-in: the engine's own calculation",
    "inUse": "Your formula is in use",
    "none": "No items match.",
    "kinds": {
      "APPLIES_WHEN": "Applies when",
      "PROVIDED": "Proposed",
      "PERMISSIBLE": "Permissible"
    },
    "explain": {
      "APPLIES_WHEN": "A condition: the check is made only where it is true, e.g. building_height > 15.6. Elsewhere it is shown as not applying, and doesn't count.",
      "PROVIDED": "The value taken from the drawing, e.g. (footprint_area + balcony_area) / net_plot_area * 100. Left empty, the engine measures it.",
      "PERMISSIBLE": "The limit, e.g. max(1.8, 0.2 * building_height) or band(building_height, [10.56, 13.86], [1.8, 2.4, 3.6]). Left empty, the rule set gives it."
    },
    "comparison": {
      "AT_MOST": "Accepted when the proposed value is at most the permissible one ({{unit}}).",
      "AT_LEAST": "Accepted when the proposed value is at least the permissible one ({{unit}})."
    },
    "formula": "Formula",
    "formulaHint": "Numbers, measurements, + - * /, brackets, comparisons, and, or, not, and the functions listed.",
    "reads": "The formula reads.",
    "readsWith": "The formula reads. It uses: {{names}}.",
    "notes": "Notes (optional): why, which byelaw",
    "save": "Save the formula",
    "saved": "Saved. Your authority's next check uses it.",
    "useBuiltIn": "Use the built-in calculation",
    "variables": "Measurements",
    "variablesHint": "Click one to put it in the formula you're writing.",
    "searchVariables": "Find a measurement",
    "functions": "Functions",
    "scopes": {
      "floor": "per floor",
      "room": "per room",
      "check": "this check"
    },
    "try": "Try it on a drawing",
    "tryIntro": "The item's results on one of your authority's checked drawings, with the formulas saved now and with those above. Nothing is saved.",
    "noSamples": "No checked drawings yet: your authority's applications appear here once their drawings are checked.",
    "drawing": "Drawing",
    "tryButton": "Try",
    "where": "Where",
    "before": "Now",
    "after": "With these formulas",
    "noResults": "This drawing has no result for this item.",
    "linkClause": "Link a byelaw clause",
    "parameter": "Must be accepted or measured only: {{name}}",
    "backToList": "All formulas",
    "noSuchItem": "There is no such item."
  },
  "byelawRegister": {
    "title": "Byelaw register",
    "intro": "The byelaw clauses your authority applies, each linked to the scrutiny parameters and bylaw items that check it. Fill it from your state's byelaw knowledge base, then edit, add or link clauses.",
    "seed": "Fill from the knowledge base",
    "seedHint": "Adds the clauses the register lacks, with their starting links; clauses already here are kept as they are.",
    "seeded": "Added {{clauses}} clauses and {{links}} links.",
    "addTitle": "Add a clause",
    "add": "Add the clause",
    "number": "Number",
    "clauseTitle": "Title",
    "text": "Text",
    "links": "Links",
    "search": "Find a clause (number, title or text)",
    "none": "No clauses yet",
    "noneBody": "Fill the register from the knowledge base, or add a clause.",
    "source": "From {{source}}",
    "save": "Save the clause",
    "saved": "Saved.",
    "checkedBy": "Checked by",
    "checkedByIntro": "The scrutiny parameters and bylaw items that check this clause. They link back here.",
    "parameters": "Scrutiny parameters",
    "items": "Bylaw items (their formulas)",
    "saveLinks": "Save the links",
    "linksSaved": "Links saved.",
    "goTo": "Go to",
    "notLinked": "Nothing checks this clause yet.",
    "parameterLink": "{{name}}: must be accepted or measured only",
    "formulaLink": "{{name}}: formulas (built-in)",
    "formulaLinkCustom": "{{name}}: formulas (yours)",
    "delete": "Delete the clause",
    "deleteConfirm": "Delete clause {{number}}?",
    "deleteBody": "It and its links go; the parameters and formulas it was linked to stay as they are. The Activity log keeps a record.",
    "backToList": "Byelaw register"
  },
  "plotAnswers": {
    "title": "About the plot",
    "intro": "The drawing can't show these. The plot size and width rules depend on them; unanswered, those rules aren't checked. Both answers are printed in the scrutiny report.",
    "withinUlb": "Is the plot within an Urban Local Body (ULB) area?",
    "withinUlbHint": "A municipal corporation, municipal board or town committee area.",
    "ewsLig": "Is the building EWS/LIG housing?",
    "ewsLigHint": "For the economically weaker section (EWS) or lower income group (LIG).",
    "choose": "Choose",
    "yes": "Yes",
    "no": "No",
    "dwellings": "How many dwellings will the building hold? (optional)",
    "dwellingsHint": "A house is one dwelling; a flat on each floor is a dwelling each.",
    "dwellingsInvalid": "Enter a whole number from 1 to 99, or leave it empty.",
    "required": "Choose yes or no."
  },
  "byelawInputs": {
    "title": "For the byelaws knowledge base",
    "intro": "The drawing can't show these. Leave a field as \"Not known\" and an officer checks the byelaws that depend on it.",
    "regime": "Plot and setback standards",
    "regimeHint": "Byelaws 24 and 26 (Planning Permit) or Byelaw 83 (Building Permit). Not given, Byelaws 24 and 26 apply.",
    "cbd": "In a Central Business District",
    "toc": "On a Transit Oriented Corridor",
    "notKnown": "Not known",
    "yes": "Yes",
    "no": "No",
    "regimeDefault": "Not given (Byelaws 24 and 26)"
  },
  "conversion": {
    "title": "Convert to the drawing standard: {{name}}",
    "intro": "Box each drawing on the sheet, then trace or draw its areas. The tool measures and suggests; nothing is added until you confirm it. Your drawing is never changed: the standard's layers are added to a copy, which is then checked.",
    "back": "Back to the check",
    "loading": "Opening the drawing…",
    "cantStart": "This drawing can't be converted yet",
    "saving": "Saving…",
    "saved": "All changes saved",
    "saveFailed": "Your latest changes aren't saved. Check your connection.",
    "alreadyConverted": "You've already converted this drawing once.",
    "seeConverted": "See the converted drawing's check",
    "stepsLabel": "Steps",
    "steps": {
      "views": "Views",
      "site": "Site",
      "floors": "Floors",
      "heights": "Heights",
      "details": "Plot details",
      "check": "Check and finish"
    },
    "stepLeft_one": "{{count}} to do",
    "stepLeft_other": "{{count}} to do",
    "chooseView": "Choose the view",
    "viewKinds": {
      "SITE": "Site plan",
      "FLOOR": "Floor plan",
      "SECTION": "Section",
      "LOCATION": "Location plan",
      "OTHER": "Other"
    },
    "floor": {
      "ground": "Ground floor",
      "basement": "Basement {{number}}",
      "upper": "Floor {{number}}"
    },
    "methods": {
      "INSIDE": "Click inside",
      "OUTLINE": "Outline",
      "MERGE": "Join parts",
      "RECT": "Rectangle",
      "POLYGON": "Draw"
    },
    "tools": {
      "viewBox": "Box a view",
      "divider": "Divider",
      "frontEdge": "Road side",
      "pickDimension": "Pick a dimension"
    },
    "hints": {
      "INSIDE": "Click inside the area. Doorways narrower than the width set are closed. Press Escape to stop.",
      "OUTLINE": "Click inside what to outline. Then shift-click any enclosed area that should stay outside it, such as a road or a ramp drawn against it.",
      "MERGE": "Click the first and last parts (for a stair, the landing and the far end of each flight); everything between joins. Press Enter to finish.",
      "RECT": "Click two opposite corners. Clicks snap to the nearest line end.",
      "POLYGON": "Click each corner. Clicks snap to line ends. Press Enter or double-click to close the shape.",
      "viewBox": "Click two opposite corners of the view.",
      "divider": "Click the two ends of a divider, for instance where an open living room meets the dining room.",
      "frontEdge": "Click two points along the plot's edge on the road.",
      "pickDimension": "Click a dimension in the section."
    },
    "kinds": {
      "PLOT": "Plot",
      "FOOTPRINT": "Building footprint",
      "COVERED_AREA": "Covered area",
      "YARD_FRONT": "Front yard",
      "YARD_REAR": "Rear yard",
      "YARD_SIDE1": "Side yard 1",
      "YARD_SIDE2": "Side yard 2",
      "SEPTIC_TANK": "Septic tank",
      "RWH": "Rain-water harvesting tank",
      "PERCOLATION_PIT": "Percolation pit",
      "RECREATIONAL": "Recreational space",
      "DRY_SUMP": "Dry sump",
      "WATER_TREATMENT": "Water treatment plant",
      "BIODEGRADABLE_WASTE": "Waste management (garbage pit)",
      "OPEN_PARKING": "Open parking area",
      "NORTH_ARROW": "North arrow",
      "LOCATION_PLAN": "Location plan",
      "BUA": "Built-up area",
      "DEDUCTION": "Deduction",
      "UNIT": "Unit outline",
      "ROOM": "Room",
      "CARPET_EXTRA": "Carpet area (lobby, passage)",
      "STAIR": "Staircase",
      "FIRE_STAIR": "Fire staircase",
      "LIFT": "Lift",
      "LOBBY": "Lobby",
      "CORRIDOR": "Corridor or passage",
      "PARKING": "Parking area",
      "PARKING_BAY": "Parking bay",
      "BALCONY_PROJECTED": "Balcony (projecting)",
      "BALCONY": "Balcony (within the building)",
      "VERANDAH": "Verandah",
      "CUPBOARD": "Wardrobe or cupboard",
      "MEZZANINE": "Mezzanine",
      "RAMP": "Ramp",
      "NOT_COUNTED": "Left out"
    },
    "rooms": {
      "BEDROOM": "Bedroom",
      "LIVING": "Living room",
      "DINING": "Dining room",
      "GENERAL ROOM": "General room",
      "CLASSROOM": "Classroom",
      "SHOP": "Shop",
      "KITCHEN": "Kitchen",
      "BATH": "Bathroom or toilet",
      "WC": "WC",
      "ACCESSIBLE WC": "Accessible WC",
      "STORE": "Store",
      "POOJA": "Pooja room"
    },
    "occupancy": {
      "151": "Residential: several units",
      "25": "Residential: one unit",
      "2": "Apartment or flat",
      "5": "Lodge",
      "193": "Shared accommodation",
      "30": "Commercial",
      "35": "Office",
      "39": "Restaurant",
      "10": "Industrial: light",
      "33": "Industrial: medium",
      "34": "Industrial: flatted",
      "9": "Industrial: standalone factory",
      "20": "Hospital",
      "21": "Clinic",
      "60": "Pre-nursery",
      "80": "Nursery school",
      "40": "Primary school",
      "15": "Higher educational institute",
      "4": "College",
      "162": "Training academy",
      "72": "Assembly",
      "78": "Commercial amenities",
      "12": "Storage",
      "22": "Hazardous"
    },
    "recreation": {
      "105": "Organised open space",
      "124": "Landscaping",
      "106": "Evergreen trees",
      "120": "Recreational open space",
      "122": "Unpaved area"
    },
    "bays": {
      "1": "Car",
      "5": "Two-wheeler",
      "6": "Visitor",
      "4": "Electric vehicle",
      "2": "Disabled"
    },
    "pending": {
      "tracing": "Tracing…",
      "title": "Add this {{what}}?",
      "area": "{{area}} m²",
      "size": "{{width}} × {{length}} m",
      "opening": "Doorways up to {{width}} m were closed to find it.",
      "label": "The drawing's label: {{text}}.",
      "sizeMatches": "Its size matches.",
      "sizeDiffers": "Its size differs from the label.",
      "add": "Add",
      "addAs": "Add as {{room}}",
      "discard": "Discard"
    },
    "items": {
      "title": "Added in this view",
      "none": "Nothing added in this view yet.",
      "area": "{{area}} m²",
      "show": "Show {{name}}",
      "remove": "Remove {{name}}"
    },
    "noViews": {
      "title": "No {{kind}} yet",
      "body": "Box it on the sheet in the first step.",
      "go": "Go to views"
    },
    "views": {
      "intro": "Box each drawing you need: the site plan, every floor plan, and the section. The tool has found the views below from their titles; check each one.",
      "suggested": "Found on the sheet",
      "addAll": "Add all",
      "add": "Add",
      "factorShort": "× {{factor}}",
      "yours_one": "Your view",
      "yours_other": "Your views ({{count}})",
      "draw": "Box a view",
      "none": "No views yet.",
      "newName": "View {{number}}",
      "name": "Name",
      "kind": "What it is",
      "factor": "Drawn at",
      "factorHint": "A 1:200 site plan on a 1:100 sheet is drawn at half size.",
      "factors": {
        "1": "The sheet's scale",
        "2": "Half size (× 2)",
        "0_5": "Double size (× 0.5)",
        "4": "Quarter size (× 4)",
        "0_25": "Four times size (× 0.25)"
      },
      "floor": "Floor",
      "alsoFloors": "Also drawn for floors",
      "alsoFloorsHint": "For a typical floor: the other floors it shows, such as 2, 3 or 2-5.",
      "occupancy": "Occupancy",
      "show": "Show",
      "redraw": "Box again",
      "remove": "Remove",
      "removeWithAreas_one": "Remove with its {{count}} area",
      "removeWithAreas_other": "Remove with its {{count}} areas"
    },
    "site": {
      "secondView": "This is a second site plan. Outline its plot too, so its tanks and pits line up with the main site plan.",
      "plot": "Plot",
      "plotDone": "Plot outlined: {{area}} m²",
      "plotTodo": "Outline the plot: click inside it, between its boundary and the building.",
      "declared": "the drawing says {{area}} m²",
      "footprint": "Building footprint",
      "footprintDone": "Footprint outlined: {{area}} m²",
      "footprintTodo": "Outline the building.",
      "footprintHint": "Click inside the building, then shift-click the yard and anything drawn against the building, such as a ramp, to keep them out.",
      "roadSide": "Road side",
      "roadSideDone": "The plot's road side is marked.",
      "roadSideTodo": "Mark the plot's edge on the road.",
      "markRoadSide": "Mark the road side",
      "clearRoadSide": "Clear the road side",
      "setbacksAutomatic": "The four setback yards are worked out from the plot, the footprint and the road side.",
      "features": "Tanks, pits and other site features",
      "featuresHint": "Add only what the drawing shows; the checklist lists what it lacks.",
      "feature": "Feature",
      "recreationKind": "Kind",
      "capacity": "Capacity (litres)"
    },
    "floors": {
      "alsoFor": "also drawn for {{floors}}",
      "builtUp": "Built-up area",
      "builtUpDone": "Built-up area: {{area}} m²",
      "builtUpTodo": "Outline the floor's built-up area.",
      "units": "Units (flats)",
      "chooseUnit": "Choose the unit",
      "unitShort": "Unit {{unit}}",
      "newUnit": "New unit",
      "unitHint": "Rooms and balconies go into the unit chosen here. Outline each unit, walls included.",
      "unitIsBuiltUp": "The whole built-up area is unit {{unit}}",
      "rooms": "Rooms of unit {{unit}}",
      "roomType": "Room type",
      "carpetHint": "A lobby or passage inside the unit counts in its carpet area, but isn't a room:",
      "findRooms": "Find the labelled rooms",
      "finding": "Finding rooms…",
      "noRoomsFound": "No labelled rooms found in this view.",
      "roomsFoundHint": "Each area around a label, traced. Check each, then accept it into unit {{unit}}.",
      "accept": "Accept",
      "skip": "Skip",
      "acceptAll_one": "Accept the {{count}} shown",
      "acceptAll_other": "Accept all {{count}} shown",
      "shared": "Stairs, lifts and other areas",
      "sharedKind": "Area",
      "bayKind": "Bay for",
      "helpers": "Helpers",
      "opening": "Close doorways narrower than (m)",
      "openingHint": "When you click inside a room, it stops at doorways narrower than this.",
      "drawDivider": "Draw dividers",
      "removeDividers_one": "Remove the divider",
      "removeDividers_other": "Remove the {{count}} dividers",
      "mirror": "Copy unit {{from}} as unit {{to}}, mirrored:",
      "mirrorTopBottom": "Top to bottom",
      "mirrorLeftRight": "Left to right",
      "balconyDistance": "Distance from the balconies to the plot boundary (m)",
      "balconyDistanceHint": "The shortest distance, as on the site plan."
    },
    "heights": {
      "suggest": "From the section's labels",
      "suggestHint": "The tool reads the section's level labels (GROUND FLOOR LV, 1ST FLOOR, PLINTH LEVEL, PARAPET) and any levels written beside them (+3600) to suggest which dimension is which.",
      "suggestButton": "Suggest the heights",
      "noneFound": "No heights found. Pick them one by one below.",
      "notToScale": "This section isn't drawn to scale: the heights written on it differ from the lengths drawn. Each height is taken as written, and the checklist lists them.",
      "asWritten": "as written (drawn {{drawn}} m)",
      "fromLevels": "from the levels written on the section",
      "writtenTag": "As written",
      "useWritten": "Use the written {{value}} m",
      "useDrawn": "Use the drawn {{value}} m",
      "unreadable": "Not readable",
      "use_one": "Use this height",
      "use_other": "Use these {{count}} heights",
      "yours": "Heights",
      "none": "No heights yet.",
      "remove": "Remove this height",
      "buildingNeeded": "The building's height is needed.",
      "pick": "Pick a dimension",
      "target": "Height",
      "targets": {
        "FLOOR_HEIGHT": "Floor height",
        "PLINTH": "Plinth height",
        "BUILDING": "Building height",
        "BUILDING_EXCLUDING_MP": "Height without the lift machine room",
        "PARAPET": "Parapet height",
        "STAIR_COVER": "Stair cover (mumty) height",
        "ROOF_TANK": "Roof tank height"
      },
      "pickButton": "Pick it in the drawing",
      "noMachineRoom": "There is no lift machine room: the height without it is the building's height."
    },
    "details": {
      "intro": "What the plan states about the plot. The tool fills in what it found written on the drawing.",
      "keys": {
        "PLOT_AREA_M2": "Plot area (m²)",
        "ROAD_WIDTH": "Road width (m)",
        "AREA_TYPE": "Area type",
        "PROPOSED_ROAD_WIDTH_REQUIRED": "Road widening proposed",
        "SERVICE_TYPE": "Application for",
        "PLOT_NO": "Plot number"
      },
      "options": {
        "YES": "Yes",
        "NO": "No",
        "NEW": "A new building",
        "ADDITION": "An addition",
        "ALTERATION": "An alteration",
        "REVISION": "A revision"
      },
      "notSaid": "Not stated",
      "useSuggested": "Use {{value}}, as written on the drawing"
    },
    "check": {
      "intro": "The checklist makes sure nothing in the drawing is missed: every enclosed area is traced or left out with a reason, and the drawing's own figures agree.",
      "run": "Run the checklist",
      "running": "Checking…",
      "stale": "You've changed the conversion since: run the checklist again.",
      "ready": "Nothing is left unaccounted for",
      "readyBody_one": "The conversion adds {{count}} shape to a copy of the drawing.",
      "readyBody_other": "The conversion adds {{count}} shapes to a copy of the drawing.",
      "notReady_one": "{{count}} item needs you before the drawing can be converted",
      "notReady_other": "{{count}} items need you before the drawing can be converted",
      "groups": {
        "MUST_one": "To deal with ({{count}})",
        "MUST_other": "To deal with ({{count}})",
        "CHECK_one": "To confirm ({{count}})",
        "CHECK_other": "To confirm ({{count}})",
        "NOTE_one": "For your information ({{count}})",
        "NOTE_other": "For your information ({{count}})"
      },
      "severity": {
        "MUST": "To deal with",
        "CHECK": "To confirm",
        "NOTE": "Information"
      },
      "show": "Show",
      "assign": "It is…",
      "assignAs": "Add it as",
      "unit": "Unit",
      "assignConfirm": "Add",
      "leaveOut": "Leave it out",
      "reason": "Why it isn't counted",
      "reasonHint": "For instance: a sunshade, not floor space. The officer sees this.",
      "leaveOutConfirm": "Leave it out",
      "finish": "Convert and check the drawing",
      "converting": "Converting…",
      "finishHint": "A copy of your drawing gets the standard's layers and is checked as a new pre-check."
    },
    "findings": {
      "NO_PLOT": "Outline the plot on a site plan.",
      "NO_FOOTPRINT": "Outline the building's footprint on the site plan.",
      "NO_ROAD_SIDE": "Mark the plot's side on the road.",
      "NO_GROUND_FLOOR": "Add the ground floor plan as a view.",
      "NO_BUILT_UP_AREA": "Outline the built-up area of {{view}}.",
      "NO_BUILDING_HEIGHT": "Pick the building's height in the section.",
      "UNACCOUNTED_AREA": "An enclosed area of {{area}} m² in {{view}}'s built-up area isn't traced.",
      "PROJECTION": "An enclosed area of {{area}} m² against {{view}}'s built-up area, outside it: a balcony, verandah or projection.",
      "AREA_MATCHES": "{{view}}: the built-up area, {{area}} m², matches the {{figure}} m² written on the drawing.",
      "AREA_DIFFERS": "{{view}}: the built-up area is {{area}} m²; no area written on the drawing matches it.",
      "MUCH_UNTRACED": "{{view}}: {{share}}% of the built-up area is walls or untraced.",
      "SIZE_DIFFERS": "{{view}}: {{label}} measures {{width}} × {{length}} m.",
      "LABEL_UNTRACED": "{{view}}: {{label}} has no area traced.",
      "NO_UNITS": "{{view}} has rooms but no unit outlined.",
      "PLOT_DIFFERS": "The plot measures {{area}} m²; the plot details say {{declared}} m².",
      "FOOTPRINT_DIFFERS": "The footprint ({{footprint}} m²) and the ground floor ({{ground}} m²) differ.",
      "MANDATORY_MISSING": "The drawing has no {{feature}} (layer {{layer}}): the check will report it.",
      "HEIGHT_AS_WRITTEN": "{{height}}: {{written}} m, as written on the drawing, where it is drawn {{drawn}} m long. The converted drawing gives it as written.",
      "HEIGHT_REUSED": "{{floor}} has the same height as {{from}}, from the same dimension or levels."
    }
  },
  "roadWidening": {
    "title": "Proposed road widths",
    "intro": "Your plot is on {{count}} roads. Enter each road's width once widened, as the Master Plan gives it (or byelaw 23 where it gives none), or today's width if it won't be widened. The front is on the road widest once widened (of roads as wide, the one your form gives), the rear opposite it, and the other two are sides 1 and 2. A side or the rear along a road must keep the front setback, and leave room for that road's widening.",
    "incomplete": "Enter every road's proposed width, then check the setbacks again: until then the setbacks along those roads aren't checked, and the drawing can't be submitted.",
    "along": {
      "front": "Along the front.",
      "rear": "Along the rear.",
      "side1": "Along side 1.",
      "side2": "Along side 2."
    },
    "road": "“{{road}}”: proposed width in metres",
    "existing": "Today: {{width}} m, as your drawing writes it.",
    "formRoad": "Filled in from your form.",
    "noWidth": "Your drawing doesn't write this road's width: write it in the road's note.",
    "required": "Enter this road's proposed width: today's width if it won't be widened.",
    "sameAsToday": "Same as today ({{width}} m)",
    "sameAsTodayFor": "Same as today for “{{road}}”",
    "save": "Check the setbacks again",
    "saved": "Setbacks checked again with these widths: the results and the scrutiny report below are updated."
  },
  "reading": {
    "title": "How we read your drawing",
    "intro": "Your drawing is read by its colours, its plan titles, its room names and its road notes. Check that every plan and road was found.",
    "plans": "Plans found from their titles",
    "noPlans": "No plan title was found. Write each plan's title under it, such as GROUND FLOOR PLAN.",
    "shows": "shows {{floors}}",
    "showsExisting": "shows {{floors}}, standing already",
    "mezzanine": "{{floor}}'s mezzanine",
    "replaced": "not measured: a plan without EXISTING shows the same floor as it will stand",
    "road": "Road",
    "noRoad": "No road note was found beside the plot, so the setbacks aren't measured. Write the road's width beside the plot, such as 5.4 M WIDE ROAD.",
    "roadWidth": "Road width used: {{width}} m",
    "widerRoad": "The wider road's width is used: {{width}} m",
    "roadAlong": {
      "front": "the front",
      "rear": "along the rear",
      "side1": "along side 1",
      "side2": "along side 2"
    },
    "items": "Read by their colours",
    "noItems": "Nothing was drawn in the card's colours.",
    "rooms_one": "{{count}} room named by its label.",
    "rooms_other": "{{count}} rooms named by their labels.",
    "roomsUnnamed_one": "{{count}} room has no label naming it.",
    "roomsUnnamed_other": "{{count}} rooms have no label naming them.",
    "byLayerNames": "Some outlines are on standard layers and were read by their layer names.",
    "traced": {
      "title": "Traced from your drawing's lines",
      "intro": "These aren't drawn in the card's colours, so the check traced the outlines from your walls and boundary lines, and read the heights from your section's dimensions. Each is used only because it agrees with a figure your drawing writes. On the drawing the outlines are shown in the card's colours, on the layer TRACED BY THE CHECK.",
      "measures": "measures {{value}} {{unit}}",
      "units": {
        "m2": "m²",
        "m": "m"
      },
      "against": {
        "AREA_CHART": "your area chart writes {{figure}} {{unit}}",
        "PLOT_AREA": "your drawing writes the plot area as {{figure}} {{unit}}",
        "GROUND_FLOOR": "the ground floor measures {{figure}} {{unit}}",
        "BUILDING_HEIGHT": "part of the building's height dimensioned over it, {{figure}} {{unit}}",
        "FLOOR_HEIGHTS": "the plinth and floor heights under it add up to {{figure}} {{unit}}",
        "EDGE": "on the floor's edge, left out of the floor your area chart agrees with: a projecting balcony",
        "FLIGHTS": "around its flights' {{figure}} treads, beside its UP or DN",
        "WRITTEN_SIZE": "the size its label writes gives {{figure}} {{unit}}",
        "WRITTEN_AREA": "its label writes {{figure}} {{unit}}",
        "LABEL": "its name is written inside it"
      },
      "rooms_one": "{{count}} room was traced from your walls, agreeing with the size its label writes.",
      "rooms_other": "{{count}} rooms were traced from your walls, each agreeing with the size its label writes."
    }
  },
  "guide": {
    "titles": {
      "mmsgna": "MMSGNA drawing guide",
      "aubb": "AUBB colour card drawing guide"
    },
    "description": "Pick what you're about to draw. Its colour, its layer and what to write in it are here to copy into AutoCAD, one line at a time, as a plain value or as a command.",
    "setUp": {
      "title": "Before you start",
      "intro": "Make the card's layers once in each drawing, or start from the template, which has them. Layers are optional: the check reads the colour.",
      "everyLayer": "Make all {{count}} layers",
      "everyLayerHint": "Each layer in its colour; you end on layer 0.",
      "orLisp": "Or, with {{file}} loaded (APPLOAD), type:",
      "paste": "A command: click AutoCAD's command line, press Ctrl+V, then Enter if it waits. A value: paste it where AutoCAD asks for it, as a layer's name, a colour or a text.",
      "hide": "Hide",
      "show": "Show"
    },
    "files": {
      "template": "Template drawing (.dxf)",
      "autolisp": "{{file}}",
      "pdf": "Printable guide (PDF)"
    },
    "searchLabel": "Find what you're drawing",
    "searchPlaceholder": "Room, kitchen, septic, 140…",
    "searchHint": "Type a name, a label such as KITCHEN, a layer or a colour number. Press / to come back here.",
    "listLabel": "The colour card",
    "listHelp": "{{count}} items. The up and down arrow keys move between them.",
    "noMatch": "Nothing matches “{{query}}”. Try a room's name, a colour number or a layer.",
    "places": {
      "SITE": "Site plan",
      "FLOOR": "Floor plans",
      "SECTION": "Section"
    },
    "kindOutline": "Closed outline",
    "kindHeight": "Height dimension",
    "colourLine": "Colour {{colour}} · {{name}}",
    "drawn": "Drawn",
    "markDrawn": "Mark as drawn",
    "steps": {
      "setUp": "Set it up in AutoCAD",
      "draw": "Draw it",
      "dimension": "Dimension it",
      "write": "Write in it"
    },
    "rows": {
      "layer": "Layer name",
      "makeLayer": "Make the layer and use it",
      "makeLayerHint": "Makes the layer in its colour if it isn't there, and puts you on it.",
      "setLayer": "Use the layer",
      "setLayerHint": "When the layer is already in the drawing.",
      "byLayer": "Draw in the layer's colour",
      "byLayerHint": "On its layer, what you draw takes the layer's colour (ByLayer).",
      "colour": "Colour number",
      "colourHint": "AutoCAD's Index Color, to draw without layers.",
      "colourCommand": "Draw in this colour",
      "colourCommandHint": "Without layers: what you draw next takes this colour."
    },
    "kindValue": "Value",
    "kindCommand": "Command",
    "copy": "Copy",
    "copied": "Copied",
    "copyWhat": "Copy {{what}}",
    "copiedSaid": "Copied {{what}}",
    "copyFailed": "Couldn't copy",
    "copyFailedHow": "Select the text and press Ctrl+C instead.",
    "nothingToWrite": "Nothing to write: its colour says what it is.",
    "nothingToWriteHeight": "Nothing to write. In a section not drawn to scale, type the height's value over the dimension.",
    "avoid": "Avoid",
    "progress": {
      "title": "My drawing",
      "reset": "Start again",
      "count": "{{drawn}} of {{count}} drawn"
    },
    "sketchLabel": "Where the {{item}} goes: {{place}}",
    "sketch": {
      "SITE": "Where it sits in the site plan.",
      "FLOOR": "Where it sits in a floor plan.",
      "SECTION": "Where it is dimensioned in the section."
    },
    "labelKinds": {
      "ROOM_NAME": "The room's name",
      "ROAD_NOTE": "A road note, outside the plot beside the road",
      "PLOT_AREA": "The plot's area (optional)",
      "SITE_TITLE": "The site plan's title",
      "PLAN_TITLE": "Each floor plan's title, under the plan",
      "LOBBY_NAME": "A lobby's name (a corridor needs none)",
      "SERVICE_NAME": "The service's name, inside its outline",
      "OPEN_SPACE_KIND": "The open space's kind, inside its outline",
      "BUILDING_NAME": "The building's name, with several buildings on the plot",
      "USE_NAME": "A room's name that says what its floor is used for",
      "WORDS": "Words read inside it"
    },
    "labels": {
      "room": "Room",
      "width": "Width (m)",
      "length": "Length (m)",
      "metres": "A size in metres, up to 30",
      "spellings": "Any of these is read the same:",
      "roomLabel": "Write inside the room",
      "roomHint": "Add its size to have it checked against the outline.",
      "roomHintSized": "The size is checked against the room's outline.",
      "roadWidth": "Road width (m)",
      "roadLabel": "Write beside the road",
      "roadHint": "On a corner plot, one note beside each road.",
      "plotArea": "Plot area (m²)",
      "plotAreaLabel": "Write anywhere on the sheet",
      "plotAreaHint": "Compared with the plot as drawn.",
      "figure": "A positive number, up to {{max}}",
      "example": "An example: type your figure to make yours.",
      "tank": "Tank",
      "litres": "Capacity (litres)",
      "tankLabel": "Write inside the tank",
      "tankHint": "Its capacity is checked against the rules.",
      "buildingHint": "Write each building's name inside its outline in the site plan, and in the titles of its plans and sections: BLOCK A FIRST FLOOR PLAN, SECTION X-X (BLOCK A). With one building, no name is needed.",
      "useHint": "A room named one of these makes its floor that use; a floor with none of them is read as homes.",
      "readAs": "read as: {{text}}"
    },
    "items": {
      "PLOT": {
        "how": [
          "In the site plan, trace the plot's boundary as one closed polyline.",
          "Write a road note outside the plot, beside the side the road is on; on a corner plot, one beside each road.",
          "If you like, write the plot's area anywhere on the sheet: it is compared with the plot as drawn."
        ],
        "avoid": [
          "A boundary left open at a corner, or drawn in pieces.",
          "No road note: the front, the setbacks and the road width can't be worked out (L009)."
        ]
      },
      "BUILDING": {
        "how": [
          "In the site plan, trace the building's outline at plinth level as one closed polyline.",
          "MMSGNA checks one building on a plot."
        ],
        "avoid": [
          "Tracing the roof or the projections instead of the plinth.",
          "Two separate building outlines on one plot (L008)."
        ]
      },
      "SERVICES": {
        "how": [
          "In the site plan, draw each septic tank, rainwater tank, recharge pit, dry sump and garbage pit as a closed outline.",
          "Write its name inside it, and a tank's capacity after its name.",
          "Draw as many recharge pits as the plot needs: the result page shows how many the rules ask for."
        ],
        "avoid": [
          "A septic tank without its capacity: its check fails as not measured.",
          "Two names in one outline: it isn't read."
        ]
      },
      "OPEN_SPACE": {
        "how": [
          "In the site plan, draw each open space as a closed outline.",
          "Write its kind inside it: landscaping, organised or recreational open space, trees or an unpaved area.",
          "The rules ask for landscaping as a share of the plot: the result page shows how much."
        ],
        "avoid": [
          "An open space with no kind written in it: it isn't read.",
          "Two open spaces drawn on top of each other: they can't be told apart."
        ]
      },
      "FLOOR": {
        "how": [
          "In each floor plan, trace the floor's outer face as one closed polyline.",
          "Title each plan under it with its floor: GROUND FLOOR PLAN, FIRST FLOOR PLAN, or one plan for floors drawn alike."
        ],
        "avoid": [
          "A plan with no title: its outlines are on no floor (L006).",
          "Two plans titled with the same floor (L007)."
        ]
      },
      "ROOM": {
        "how": [
          "Trace each room on the inner faces of its walls as a closed polyline, inside its floor's outline.",
          "Write the room's name inside it, with its size if you like.",
          "Draw a verandah or sit-out in this colour too, with VERANDAH written in it: it is counted in the floor's area, with no exemption, and isn't checked as a room."
        ],
        "avoid": [
          "A name that sits across a wall or in the next room (L010, L011).",
          "Two rooms' names in one outline, such as KITCHEN CUM DINING: name each room."
        ]
      },
      "STAIRCASE": {
        "how": [
          "On each floor, trace the whole staircase, its flights and landings, as one closed polyline."
        ],
        "avoid": ["A staircase drawn only as its flights."]
      },
      "STAIR_FLIGHT": {
        "how": [
          "Trace each flight as a closed polyline inside its staircase's outline.",
          "Keep the step lines across it: they count the risers."
        ],
        "avoid": ["A flight outside its staircase's outline: it isn't counted (L012)."]
      },
      "BALCONY": {
        "how": [
          "Trace each balcony or projection as a closed polyline in its floor plan.",
          "One outside the floor's outline projects; one inside it is within the floor.",
          "Draw a wardrobe or cupboard projecting from a room's outer wall in this colour, with WARDROBE written in it: it is checked as a cantilever cupboard, at most 0.75 m deep and 2 m long beside each habitable room, from the first floor up."
        ],
        "avoid": [
          "A chajja or canopy in this colour: it is read as a balcony.",
          "WARDROBE written in a balcony without its own outline: the whole balcony is read as a wardrobe. Draw the wardrobe as its own outline, even inside the balcony's."
        ]
      },
      "PARKING": {
        "how": [
          "Trace the parking area as a closed polyline, and each car bay as a closed polyline inside it.",
          "Parking in the site plan needs the site plan's title (SITE PLAN)."
        ],
        "avoid": ["A bay drawn outside its parking area: it is read as parking area, not a bay."]
      },
      "LIFT": {
        "how": ["Trace the lift's shaft as a closed polyline on each floor it serves."],
        "avoid": ["A lift drawn on only one floor of a typical plan's floors."]
      },
      "CORRIDOR": {
        "how": [
          "Trace a corridor or a lobby as a closed polyline.",
          "Write LOBBY or FOYER inside a lobby; without it, the outline is read as a corridor."
        ],
        "avoid": ["A lobby's name outside its outline: it is read as a corridor."]
      },
      "BUILDING_HEIGHT": {
        "how": [
          "In the section, dimension the building's height from ground level to the top of the roof slab, in this colour."
        ],
        "avoid": [
          "A height dimensioned to the parapet or the stair cover instead of the roof slab."
        ]
      },
      "FLOOR_HEIGHT": {
        "how": [
          "In the section, dimension each floor's height once, from floor to floor, in this colour.",
          "One dimension for every floor, so each can be matched to its floor."
        ],
        "avoid": ["More or fewer floor heights than floors: they can't be matched (L002)."]
      },
      "PLINTH_HEIGHT": {
        "how": [
          "In the section, dimension the plinth from ground level to the ground floor, in this colour."
        ],
        "avoid": ["A plinth dimensioned from the road instead of the ground level."]
      },
      "UNIT": {
        "how": [
          "Trace each flat as a closed polyline on the inner faces of its walls: its carpet area.",
          "Its rooms, drawn inside it, are that flat's. Where flats are drawn, they are the building's homes."
        ],
        "avoid": ["A flat traced on the outer faces of its walls: its carpet area reads too large."]
      },
      "FIRE_TENDER_PATH": {
        "how": [
          "In the site plan, trace the fire tender's path as a closed polyline, from the road along the building."
        ],
        "avoid": ["The path drawn in a floor plan: it is read only in the site plan."]
      }
    },
    "showAll": "Show all",
    "showLess": "Show less"
  },
  "layerGuide": {
    "title": "OBPAS layer guide",
    "description": "Say which block, floor and unit you are drawing, and pick the layer. Its name, its commands and the colours that mean something on it are here to copy into AutoCAD.",
    "setUp": {
      "title": "Before you start",
      "intro": "Every layer name below is written for the block, floor and unit you give here. Or start from the template, which has the layers for block 1, floors 0 to 2.",
      "siteLayers": "Make the site's layers",
      "siteLayersHint": "Every layer of the site plan, each in its colour; you end on layer 0.",
      "floorLayers": "Make block {{block}}, floor {{floor}}'s layers",
      "floorLayersHint": "The floor's layers, each in its colour. A unit's, a lift's or a staircase's are made as you draw them."
    },
    "numbers": {
      "block": "Block",
      "floor": "Floor",
      "floorHint": "0 is the ground floor; -1 the first basement.",
      "unit": "Dwelling unit",
      "index": "Number",
      "indexHint": "Of a lift, staircase, flight or landing.",
      "between": "A whole number from {{min}} to {{max}}"
    },
    "files": {
      "template": "Template drawing (.dxf)"
    },
    "searchLabel": "Find a layer",
    "searchPlaceholder": "Built-up area, kitchen, setback, 145…",
    "listLabel": "The layers",
    "noMatch": "No layer matches “{{query}}”. Try what you are drawing, a layer's word or a colour number.",
    "places": {
      "SITE": "Site plan",
      "BLOCK": "Each block, in the site plan",
      "FLOOR": "Each floor plan",
      "UNIT": "Each dwelling unit",
      "SECTION": "The section"
    },
    "mandatory": {
      "SITE": "Needed, once on the site",
      "BLOCK": "Needed for each block",
      "GROUND_FLOOR": "Needed on each block's ground floor",
      "EACH_FLOOR": "Needed on each floor",
      "ANY_FLOOR_IF_SEVERAL": "Needed in a block of more than one floor",
      "FLOORS_WITH_BALCONY": "Needed on each floor with a balcony",
      "RESIDENTIAL_UNITS": "Needed for each unit of a residential floor"
    },
    "optional": "Optional",
    "core": "Without it the drawing can't be measured",
    "steps": {
      "draw": "What to draw on it",
      "colours": "Its colours",
      "occupancy": "Its colour is its occupancy",
      "write": "Write it"
    },
    "colourText": "colour {{colour}}",
    "measures": "The check reads: {{what}}",
    "coloursIntro": "Each outline's colour says what it is. Set it with -COLOR before drawing, or in Properties.",
    "occupancyIntro": "Draw each outline in the colour of what the floor is used for.",
    "typical": "Write it as a text on {{layer}}, listing the floors drawn the same as this one.",
    "typicalText": "The text",
    "planInfo": {
      "intro": "One text (MTEXT) on this layer, its first line {{title}}, then one KEY=VALUE line each:",
      "required": "Needed",
      "optional": "Optional"
    }
  }
}
